
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea1ac"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea1ac"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f16Zt", function(module, exports) {
module.exports = $parcel$import("9i6Fk").then(()=>parcelRequire('ace6R'));

});

parcelRegister("6bf00", function(module, exports) {
module.exports = $parcel$import("4QaUD").then(()=>parcelRequire('lqg4O'));

});

parcelRegister("1qoYS", function(module, exports) {
module.exports = $parcel$import("4guuL").then(()=>parcelRequire('iy4Gx'));

});

parcelRegister("aNq9N", function(module, exports) {
module.exports = $parcel$import("i1WL8").then(()=>parcelRequire('8dR6n'));

});

parcelRegister("e1U8g", function(module, exports) {
module.exports = $parcel$import("fsoUh").then(()=>parcelRequire('2sYgo'));

});

parcelRegister("b0ekd", function(module, exports) {
module.exports = $parcel$import("gbDQq").then(()=>parcelRequire('d9Kq0'));

});

parcelRegister("e2WhP", function(module, exports) {
module.exports = $parcel$import("ao1Ym").then(()=>parcelRequire('e7Ht4'));

});

parcelRegister("hB9az", function(module, exports) {
module.exports = $parcel$import("fJnzu").then(()=>parcelRequire('1lo8u'));

});

parcelRegister("k2XGL", function(module, exports) {
module.exports = $parcel$import("e79Yb").then(()=>parcelRequire('aIDbs'));

});

parcelRegister("lLNQz", function(module, exports) {
module.exports = $parcel$import("jv5Du").then(()=>parcelRequire('hNlUI'));

});

parcelRegister("g1GOh", function(module, exports) {
module.exports = $parcel$import("2btEZ").then(()=>parcelRequire('adPfw'));

});

parcelRegister("4AQwh", function(module, exports) {
module.exports = $parcel$import("6mUP0").then(()=>parcelRequire('bpIFj'));

});

parcelRegister("grRrM", function(module, exports) {
module.exports = $parcel$import("kUHeL").then(()=>parcelRequire('exehU'));

});

parcelRegister("9DvqF", function(module, exports) {
module.exports = $parcel$import("kTsw6").then(()=>parcelRequire('2nzVc'));

});

parcelRegister("ias7f", function(module, exports) {
module.exports = $parcel$import("kQTwa").then(()=>parcelRequire('20wRu'));

});

parcelRegister("9u9zO", function(module, exports) {
module.exports = $parcel$import("dLmXg").then(()=>parcelRequire('bvPpf'));

});

parcelRegister("iDWwE", function(module, exports) {
module.exports = $parcel$import("e60JB").then(()=>parcelRequire('3EiuE'));

});

parcelRegister("6vW2c", function(module, exports) {
module.exports = $parcel$import("eFWX4").then(()=>parcelRequire('hsEHe'));

});

parcelRegister("6K5u9", function(module, exports) {
module.exports = $parcel$import("5cz81").then(()=>parcelRequire('i5gEi'));

});

parcelRegister("f2AKi", function(module, exports) {
module.exports = $parcel$import("bXu3z").then(()=>parcelRequire('hyT0Y'));

});

parcelRegister("6xa38", function(module, exports) {
module.exports = $parcel$import("etCnd").then(()=>parcelRequire('bY9tC'));

});

parcelRegister("kscXV", function(module, exports) {
module.exports = $parcel$import("a7Olh").then(()=>parcelRequire('5kjkG'));

});

parcelRegister("i2m7h", function(module, exports) {
module.exports = $parcel$import("kIYHN").then(()=>parcelRequire('kl2nj'));

});

parcelRegister("4Jy9F", function(module, exports) {
module.exports = $parcel$import("ewuoi").then(()=>parcelRequire('4OtfK'));

});

parcelRegister("4nnBo", function(module, exports) {
module.exports = $parcel$import("anpn1").then(()=>parcelRequire('dQMiv'));

});

parcelRegister("2v6yB", function(module, exports) {
module.exports = $parcel$import("gbuEE").then(()=>parcelRequire('eUVHN'));

});

parcelRegister("1GbfB", function(module, exports) {
module.exports = $parcel$import("6fopw").then(()=>parcelRequire('kyNnM'));

});

parcelRegister("knBc5", function(module, exports) {
module.exports = $parcel$import("g1sa0").then(()=>parcelRequire('cWQdn'));

});

parcelRegister("aibCe", function(module, exports) {
module.exports = $parcel$import("53ocf").then(()=>parcelRequire('43RwL'));

});

parcelRegister("ihKaL", function(module, exports) {
module.exports = $parcel$import("xKr6n").then(()=>parcelRequire('cFtwv'));

});

parcelRegister("d1tPy", function(module, exports) {
module.exports = $parcel$import("b7eTD").then(()=>parcelRequire('aqjLp'));

});

var $02cc018c743fefcb$exports = {};
$parcel$extendImportMap({
    "km6Q2": "LimbleLogo.718672e3.svg",
    "dME4c": "DHL.82f000bc.png",
    "dGBNJ": "neutron-light-background.b981cea9.png",
    "aSdYY": "enco.af8dd6b6.png",
    "kE6fw": "Deliverez_Logo_New_NoBG.1261f27b.png",
    "9L4Ri": "epicGames.5538ddcb.png",
    "iZ4C6": "iotplus-light-background.4b7825c9.png",
    "gu0ON": "invata-light-background.518c7628.png",
    "chEZm": "netswat.525ee24a.png",
    "dmGOx": "demirer-hodling.5c91f8eb.png",
    "341Ay": "Scandinavian-Drone-Logo-svart.17c393f7.png",
    "hjiHz": "2D-Comstock-Logo.1f1aa8ca.jpg",
    "c0Orn": "HarriganLogo.62e00185.png",
    "l0n69": "sentegrity.230af4aa.png",
    "4Bnt4": "Dartbrook_logo.c22bd1f9.svg",
    "dRHww": "redaptive_logo.61ab5928.svg",
    "ekACy": "LoginScreenSwoosh.f5f4b20d.svg",
    "lTqcR": "johndeere_logo.7d528477.png",
    "1bGWL": "KU.1bfb01de.svg",
    "gfAld": "homeFixLogo.16b4996c.svg",
    "7pgXg": "intelsat.c3ef53da.svg",
    "fiPpo": "jbm.12186be8.svg",
    "kUqTd": "access.ceb02b12.svg",
    "5Nbdb": "canyonRidgeServices-light.1ceacb22.svg",
    "7XRXC": "watermark-facilities-logo.db561ffb.svg",
    "iFLSi": "OFB_logo_black.c08b8aa6.png",
    "aeul6": "germantown-baptist-church.ef4ccdcc.png",
    "lDv8g": "TQL_black.2f8406a9.png",
    "9i6Fk": "en.1ec3e18c.js",
    "4QaUD": "et.3ffacfd6.js",
    "4guuL": "sl.738f8645.js",
    "i1WL8": "es.33374bba.js",
    "fsoUh": "th.4ca1e431.js",
    "gbDQq": "fr.01ee32f0.js",
    "ao1Ym": "pt.e3d80d3a.js",
    "fJnzu": "he.51f48228.js",
    "e79Yb": "de.ff9aaf0f.js",
    "jv5Du": "zh.12712427.js",
    "2btEZ": "ar.d1f4947e.js",
    "6mUP0": "bg.987a73ec.js",
    "kUHeL": "cs.7a02195e.js",
    "kTsw6": "fa.df640d32.js",
    "kQTwa": "hu.90ed03c5.js",
    "dLmXg": "it.d650b960.js",
    "e60JB": "ja.f3e8052f.js",
    "eFWX4": "ko.38c44851.js",
    "5cz81": "lv.f5702518.js",
    "bXu3z": "nl.f1aa8b70.js",
    "etCnd": "no.b6127ef2.js",
    "a7Olh": "id.41f89ed0.js",
    "kIYHN": "pl.61db4da0.js",
    "ewuoi": "ro.686f7ccd.js",
    "anpn1": "ru.fca122cb.js",
    "gbuEE": "sv.e910c479.js",
    "6fopw": "sw.781f983f.js",
    "g1sa0": "tl.49300f99.js",
    "53ocf": "tg.a5672c66.js",
    "xKr6n": "tr.ca0c86e2.js",
    "b7eTD": "vi.b346576d.js"
});

var $3c9b4787e03d1b0f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c9b4787e03d1b0f$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $3c9b4787e03d1b0f$exports));
try {
    regeneratorRuntime = $3c9b4787e03d1b0f$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $3c9b4787e03d1b0f$var$runtime;
    else Function("r", "regeneratorRuntime = r")($3c9b4787e03d1b0f$var$runtime);
}


/**
 * This is a shim to load our routes at runtime, allowing us to generate
 * routes separate from the bundled assets. This is useful because we
 * can then ship the same asset bundle in different environments without
 * needing to recompile for the different routes file in use.
 */ 'use strict';
function $cfc6b7689f4adcdd$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $ff8c5b784cd951b0$var$toString } = Object.prototype;
const { getPrototypeOf: $ff8c5b784cd951b0$var$getPrototypeOf } = Object;
const { iterator: $ff8c5b784cd951b0$var$iterator, toStringTag: $ff8c5b784cd951b0$var$toStringTag } = Symbol;
const $ff8c5b784cd951b0$var$kindOf = ((cache)=>(thing)=>{
        const str = $ff8c5b784cd951b0$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $ff8c5b784cd951b0$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$ff8c5b784cd951b0$var$kindOf(thing) === type;
};
const $ff8c5b784cd951b0$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $ff8c5b784cd951b0$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $ff8c5b784cd951b0$var$isUndefined = $ff8c5b784cd951b0$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $ff8c5b784cd951b0$var$isBuffer(val) {
    return val !== null && !$ff8c5b784cd951b0$var$isUndefined(val) && val.constructor !== null && !$ff8c5b784cd951b0$var$isUndefined(val.constructor) && $ff8c5b784cd951b0$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $ff8c5b784cd951b0$var$isArrayBuffer = $ff8c5b784cd951b0$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $ff8c5b784cd951b0$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $ff8c5b784cd951b0$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $ff8c5b784cd951b0$var$isString = $ff8c5b784cd951b0$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $ff8c5b784cd951b0$var$isFunction = $ff8c5b784cd951b0$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $ff8c5b784cd951b0$var$isNumber = $ff8c5b784cd951b0$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $ff8c5b784cd951b0$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $ff8c5b784cd951b0$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $ff8c5b784cd951b0$var$isPlainObject = (val)=>{
    if ($ff8c5b784cd951b0$var$kindOf(val) !== 'object') return false;
    const prototype = $ff8c5b784cd951b0$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($ff8c5b784cd951b0$var$toStringTag in val) && !($ff8c5b784cd951b0$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $ff8c5b784cd951b0$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$ff8c5b784cd951b0$var$isObject(val) || $ff8c5b784cd951b0$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $ff8c5b784cd951b0$var$isDate = $ff8c5b784cd951b0$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $ff8c5b784cd951b0$var$isFile = $ff8c5b784cd951b0$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $ff8c5b784cd951b0$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $ff8c5b784cd951b0$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $ff8c5b784cd951b0$var$isBlob = $ff8c5b784cd951b0$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $ff8c5b784cd951b0$var$isFileList = $ff8c5b784cd951b0$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $ff8c5b784cd951b0$var$isStream = (val)=>$ff8c5b784cd951b0$var$isObject(val) && $ff8c5b784cd951b0$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $ff8c5b784cd951b0$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $ff8c5b784cd951b0$var$G = $ff8c5b784cd951b0$var$getGlobal();
const $ff8c5b784cd951b0$var$FormDataCtor = typeof $ff8c5b784cd951b0$var$G.FormData !== 'undefined' ? $ff8c5b784cd951b0$var$G.FormData : undefined;
const $ff8c5b784cd951b0$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($ff8c5b784cd951b0$var$FormDataCtor && thing instanceof $ff8c5b784cd951b0$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $ff8c5b784cd951b0$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$ff8c5b784cd951b0$var$isFunction(thing.append)) return false;
    const kind = $ff8c5b784cd951b0$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $ff8c5b784cd951b0$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $ff8c5b784cd951b0$var$isURLSearchParams = $ff8c5b784cd951b0$var$kindOfTest('URLSearchParams');
const [$ff8c5b784cd951b0$var$isReadableStream, $ff8c5b784cd951b0$var$isRequest, $ff8c5b784cd951b0$var$isResponse, $ff8c5b784cd951b0$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($ff8c5b784cd951b0$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $ff8c5b784cd951b0$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $ff8c5b784cd951b0$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($ff8c5b784cd951b0$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($ff8c5b784cd951b0$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $ff8c5b784cd951b0$var$findKey(obj, key) {
    if ($ff8c5b784cd951b0$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $ff8c5b784cd951b0$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $ff8c5b784cd951b0$var$isContextDefined = (context)=>!$ff8c5b784cd951b0$var$isUndefined(context) && context !== $ff8c5b784cd951b0$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $ff8c5b784cd951b0$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $ff8c5b784cd951b0$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $ff8c5b784cd951b0$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $ff8c5b784cd951b0$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($ff8c5b784cd951b0$var$isPlainObject(existing) && $ff8c5b784cd951b0$var$isPlainObject(val)) result[targetKey] = $ff8c5b784cd951b0$var$merge(existing, val);
        else if ($ff8c5b784cd951b0$var$isPlainObject(val)) result[targetKey] = $ff8c5b784cd951b0$var$merge({}, val);
        else if ($ff8c5b784cd951b0$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$ff8c5b784cd951b0$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++)objs[i] && $ff8c5b784cd951b0$var$forEach(objs[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $ff8c5b784cd951b0$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $ff8c5b784cd951b0$var$forEach(b, (val, key)=>{
        if (thisArg && $ff8c5b784cd951b0$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $cfc6b7689f4adcdd$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $ff8c5b784cd951b0$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $ff8c5b784cd951b0$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $ff8c5b784cd951b0$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $ff8c5b784cd951b0$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $ff8c5b784cd951b0$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $ff8c5b784cd951b0$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($ff8c5b784cd951b0$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$ff8c5b784cd951b0$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $ff8c5b784cd951b0$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $ff8c5b784cd951b0$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $ff8c5b784cd951b0$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$ff8c5b784cd951b0$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $ff8c5b784cd951b0$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $ff8c5b784cd951b0$var$isHTMLForm = $ff8c5b784cd951b0$var$kindOfTest('HTMLFormElement');
const $ff8c5b784cd951b0$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $ff8c5b784cd951b0$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $ff8c5b784cd951b0$var$isRegExp = $ff8c5b784cd951b0$var$kindOfTest('RegExp');
const $ff8c5b784cd951b0$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $ff8c5b784cd951b0$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $ff8c5b784cd951b0$var$freezeMethods = (obj)=>{
    $ff8c5b784cd951b0$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($ff8c5b784cd951b0$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$ff8c5b784cd951b0$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $ff8c5b784cd951b0$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $ff8c5b784cd951b0$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $ff8c5b784cd951b0$var$noop = ()=>{};
const $ff8c5b784cd951b0$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $ff8c5b784cd951b0$var$isSpecCompliantForm(thing) {
    return !!(thing && $ff8c5b784cd951b0$var$isFunction(thing.append) && thing[$ff8c5b784cd951b0$var$toStringTag] === 'FormData' && thing[$ff8c5b784cd951b0$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $ff8c5b784cd951b0$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($ff8c5b784cd951b0$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($ff8c5b784cd951b0$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $ff8c5b784cd951b0$var$isArray(source) ? [] : {};
                $ff8c5b784cd951b0$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$ff8c5b784cd951b0$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $ff8c5b784cd951b0$var$isAsyncFn = $ff8c5b784cd951b0$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $ff8c5b784cd951b0$var$isThenable = (thing)=>thing && ($ff8c5b784cd951b0$var$isObject(thing) || $ff8c5b784cd951b0$var$isFunction(thing)) && $ff8c5b784cd951b0$var$isFunction(thing.then) && $ff8c5b784cd951b0$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $ff8c5b784cd951b0$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $ff8c5b784cd951b0$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $ff8c5b784cd951b0$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $ff8c5b784cd951b0$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $ff8c5b784cd951b0$var$isFunction($ff8c5b784cd951b0$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $ff8c5b784cd951b0$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($ff8c5b784cd951b0$var$_global) : $ff8c5b784cd951b0$var$_setImmediate;
// *********************
const $ff8c5b784cd951b0$var$isIterable = (thing)=>thing != null && $ff8c5b784cd951b0$var$isFunction(thing[$ff8c5b784cd951b0$var$iterator]);
var $ff8c5b784cd951b0$export$2e2bcd8739ae039 = {
    isArray: $ff8c5b784cd951b0$var$isArray,
    isArrayBuffer: $ff8c5b784cd951b0$var$isArrayBuffer,
    isBuffer: $ff8c5b784cd951b0$var$isBuffer,
    isFormData: $ff8c5b784cd951b0$var$isFormData,
    isArrayBufferView: $ff8c5b784cd951b0$var$isArrayBufferView,
    isString: $ff8c5b784cd951b0$var$isString,
    isNumber: $ff8c5b784cd951b0$var$isNumber,
    isBoolean: $ff8c5b784cd951b0$var$isBoolean,
    isObject: $ff8c5b784cd951b0$var$isObject,
    isPlainObject: $ff8c5b784cd951b0$var$isPlainObject,
    isEmptyObject: $ff8c5b784cd951b0$var$isEmptyObject,
    isReadableStream: $ff8c5b784cd951b0$var$isReadableStream,
    isRequest: $ff8c5b784cd951b0$var$isRequest,
    isResponse: $ff8c5b784cd951b0$var$isResponse,
    isHeaders: $ff8c5b784cd951b0$var$isHeaders,
    isUndefined: $ff8c5b784cd951b0$var$isUndefined,
    isDate: $ff8c5b784cd951b0$var$isDate,
    isFile: $ff8c5b784cd951b0$var$isFile,
    isReactNativeBlob: $ff8c5b784cd951b0$var$isReactNativeBlob,
    isReactNative: $ff8c5b784cd951b0$var$isReactNative,
    isBlob: $ff8c5b784cd951b0$var$isBlob,
    isRegExp: $ff8c5b784cd951b0$var$isRegExp,
    isFunction: $ff8c5b784cd951b0$var$isFunction,
    isStream: $ff8c5b784cd951b0$var$isStream,
    isURLSearchParams: $ff8c5b784cd951b0$var$isURLSearchParams,
    isTypedArray: $ff8c5b784cd951b0$var$isTypedArray,
    isFileList: $ff8c5b784cd951b0$var$isFileList,
    forEach: $ff8c5b784cd951b0$var$forEach,
    merge: $ff8c5b784cd951b0$var$merge,
    extend: $ff8c5b784cd951b0$var$extend,
    trim: $ff8c5b784cd951b0$var$trim,
    stripBOM: $ff8c5b784cd951b0$var$stripBOM,
    inherits: $ff8c5b784cd951b0$var$inherits,
    toFlatObject: $ff8c5b784cd951b0$var$toFlatObject,
    kindOf: $ff8c5b784cd951b0$var$kindOf,
    kindOfTest: $ff8c5b784cd951b0$var$kindOfTest,
    endsWith: $ff8c5b784cd951b0$var$endsWith,
    toArray: $ff8c5b784cd951b0$var$toArray,
    forEachEntry: $ff8c5b784cd951b0$var$forEachEntry,
    matchAll: $ff8c5b784cd951b0$var$matchAll,
    isHTMLForm: $ff8c5b784cd951b0$var$isHTMLForm,
    hasOwnProperty: $ff8c5b784cd951b0$var$hasOwnProperty,
    hasOwnProp: $ff8c5b784cd951b0$var$hasOwnProperty,
    reduceDescriptors: $ff8c5b784cd951b0$var$reduceDescriptors,
    freezeMethods: $ff8c5b784cd951b0$var$freezeMethods,
    toObjectSet: $ff8c5b784cd951b0$var$toObjectSet,
    toCamelCase: $ff8c5b784cd951b0$var$toCamelCase,
    noop: $ff8c5b784cd951b0$var$noop,
    toFiniteNumber: $ff8c5b784cd951b0$var$toFiniteNumber,
    findKey: $ff8c5b784cd951b0$var$findKey,
    global: $ff8c5b784cd951b0$var$_global,
    isContextDefined: $ff8c5b784cd951b0$var$isContextDefined,
    isSpecCompliantForm: $ff8c5b784cd951b0$var$isSpecCompliantForm,
    toJSONObject: $ff8c5b784cd951b0$var$toJSONObject,
    isAsyncFn: $ff8c5b784cd951b0$var$isAsyncFn,
    isThenable: $ff8c5b784cd951b0$var$isThenable,
    setImmediate: $ff8c5b784cd951b0$var$_setImmediate,
    asap: $ff8c5b784cd951b0$var$asap,
    isIterable: $ff8c5b784cd951b0$var$isIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $51ff232c44dd0673$var$ignoreDuplicateOf = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $51ff232c44dd0673$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $51ff232c44dd0673$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $3f8a3fa449b65873$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $3f8a3fa449b65873$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $3f8a3fa449b65873$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $3f8a3fa449b65873$var$sanitizeValue(value, invalidChars) {
    if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$3f8a3fa449b65873$var$sanitizeValue(item, invalidChars));
    return $3f8a3fa449b65873$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $3f8a3fa449b65873$export$9e344cffce061a22 = (value)=>$3f8a3fa449b65873$var$sanitizeValue(value, $3f8a3fa449b65873$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $3f8a3fa449b65873$export$59dd66c2a12d8f62 = (value)=>$3f8a3fa449b65873$var$sanitizeValue(value, $3f8a3fa449b65873$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $3f8a3fa449b65873$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $3f8a3fa449b65873$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $54d294f46ebe052d$var$$internals = Symbol('internals');
function $54d294f46ebe052d$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54d294f46ebe052d$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(value) ? value.map($54d294f46ebe052d$var$normalizeValue) : (0, $3f8a3fa449b65873$export$9e344cffce061a22)(String(value));
}
function $54d294f46ebe052d$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54d294f46ebe052d$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54d294f46ebe052d$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $54d294f46ebe052d$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54d294f46ebe052d$var$buildAccessors(obj, header) {
    const accessorName = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54d294f46ebe052d$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54d294f46ebe052d$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54d294f46ebe052d$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$54d294f46ebe052d$var$isValidHeaderName(header)) setHeaders((0, $51ff232c44dd0673$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isObject(header) && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54d294f46ebe052d$var$normalizeHeader(header);
        if (header) {
            const key = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54d294f46ebe052d$var$parseTokens(value);
                if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $54d294f46ebe052d$var$normalizeHeader(header);
        if (header) {
            const key = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54d294f46ebe052d$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54d294f46ebe052d$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $54d294f46ebe052d$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54d294f46ebe052d$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $54d294f46ebe052d$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54d294f46ebe052d$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54d294f46ebe052d$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54d294f46ebe052d$var$$internals] = this[$54d294f46ebe052d$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54d294f46ebe052d$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54d294f46ebe052d$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54d294f46ebe052d$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).reduceDescriptors($54d294f46ebe052d$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).freezeMethods($54d294f46ebe052d$var$AxiosHeaders);
var $54d294f46ebe052d$export$2e2bcd8739ae039 = $54d294f46ebe052d$var$AxiosHeaders;


'use strict';
const $5f470fdf41780c75$var$REDACTED = '[REDACTED ****]';
function $5f470fdf41780c75$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $5f470fdf41780c75$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $54d294f46ebe052d$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isPlainObject(source) && $5f470fdf41780c75$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $5f470fdf41780c75$var$REDACTED : visit(value);
                if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $5f470fdf41780c75$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $5f470fdf41780c75$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $5f470fdf41780c75$var$redactConfig(config, redactKeys) : (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$5f470fdf41780c75$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$5f470fdf41780c75$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$5f470fdf41780c75$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$5f470fdf41780c75$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$5f470fdf41780c75$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$5f470fdf41780c75$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$5f470fdf41780c75$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$5f470fdf41780c75$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$5f470fdf41780c75$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$5f470fdf41780c75$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$5f470fdf41780c75$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$5f470fdf41780c75$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$5f470fdf41780c75$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$5f470fdf41780c75$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $5f470fdf41780c75$export$2e2bcd8739ae039 = $5f470fdf41780c75$var$AxiosError;


// eslint-disable-next-line strict
var $52b1b290f9a96c53$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $41d7fa42227e3765$export$a143d493d941bafc;
var $41d7fa42227e3765$export$e4cf37d7f6fb9e0a;
var $41d7fa42227e3765$export$f99ded8fe4b79145;
var $41d7fa42227e3765$export$599f31c3813fae4d;
'use strict';
var $7ab3a47c4ed68956$export$a48f0734ac7c2329;
var $7ab3a47c4ed68956$export$d622b2ad8d90c771;
var $7ab3a47c4ed68956$export$6100ba28696e12de;
'use strict';
$7ab3a47c4ed68956$export$a48f0734ac7c2329 = $7ab3a47c4ed68956$var$byteLength;
$7ab3a47c4ed68956$export$d622b2ad8d90c771 = $7ab3a47c4ed68956$var$toByteArray;
$7ab3a47c4ed68956$export$6100ba28696e12de = $7ab3a47c4ed68956$var$fromByteArray;
var $7ab3a47c4ed68956$var$lookup = [];
var $7ab3a47c4ed68956$var$revLookup = [];
var $7ab3a47c4ed68956$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $7ab3a47c4ed68956$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $7ab3a47c4ed68956$var$i = 0, $7ab3a47c4ed68956$var$len = $7ab3a47c4ed68956$var$code.length; $7ab3a47c4ed68956$var$i < $7ab3a47c4ed68956$var$len; ++$7ab3a47c4ed68956$var$i){
    $7ab3a47c4ed68956$var$lookup[$7ab3a47c4ed68956$var$i] = $7ab3a47c4ed68956$var$code[$7ab3a47c4ed68956$var$i];
    $7ab3a47c4ed68956$var$revLookup[$7ab3a47c4ed68956$var$code.charCodeAt($7ab3a47c4ed68956$var$i)] = $7ab3a47c4ed68956$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$7ab3a47c4ed68956$var$revLookup['-'.charCodeAt(0)] = 62;
$7ab3a47c4ed68956$var$revLookup['_'.charCodeAt(0)] = 63;
function $7ab3a47c4ed68956$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $7ab3a47c4ed68956$var$byteLength(b64) {
    var lens = $7ab3a47c4ed68956$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7ab3a47c4ed68956$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7ab3a47c4ed68956$var$toByteArray(b64) {
    var tmp;
    var lens = $7ab3a47c4ed68956$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $7ab3a47c4ed68956$var$Arr($7ab3a47c4ed68956$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $7ab3a47c4ed68956$var$revLookup[b64.charCodeAt(i)] << 18 | $7ab3a47c4ed68956$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $7ab3a47c4ed68956$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $7ab3a47c4ed68956$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $7ab3a47c4ed68956$var$revLookup[b64.charCodeAt(i)] << 2 | $7ab3a47c4ed68956$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $7ab3a47c4ed68956$var$revLookup[b64.charCodeAt(i)] << 10 | $7ab3a47c4ed68956$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $7ab3a47c4ed68956$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $7ab3a47c4ed68956$var$tripletToBase64(num) {
    return $7ab3a47c4ed68956$var$lookup[num >> 18 & 0x3F] + $7ab3a47c4ed68956$var$lookup[num >> 12 & 0x3F] + $7ab3a47c4ed68956$var$lookup[num >> 6 & 0x3F] + $7ab3a47c4ed68956$var$lookup[num & 0x3F];
}
function $7ab3a47c4ed68956$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($7ab3a47c4ed68956$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $7ab3a47c4ed68956$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($7ab3a47c4ed68956$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($7ab3a47c4ed68956$var$lookup[tmp >> 2] + $7ab3a47c4ed68956$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($7ab3a47c4ed68956$var$lookup[tmp >> 10] + $7ab3a47c4ed68956$var$lookup[tmp >> 4 & 0x3F] + $7ab3a47c4ed68956$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $9e5150a7da551dd2$export$aafa59e2e03f2942;
var $9e5150a7da551dd2$export$68d8715fc104d294;
$9e5150a7da551dd2$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$9e5150a7da551dd2$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $41d7fa42227e3765$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$41d7fa42227e3765$export$a143d493d941bafc = $41d7fa42227e3765$var$Buffer;
$41d7fa42227e3765$export$e4cf37d7f6fb9e0a = $41d7fa42227e3765$var$SlowBuffer;
$41d7fa42227e3765$export$f99ded8fe4b79145 = 50;
const $41d7fa42227e3765$var$K_MAX_LENGTH = 0x7fffffff;
$41d7fa42227e3765$export$599f31c3813fae4d = $41d7fa42227e3765$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $41d7fa42227e3765$var$Buffer.TYPED_ARRAY_SUPPORT = $41d7fa42227e3765$var$typedArraySupport();
if (!$41d7fa42227e3765$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $41d7fa42227e3765$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($41d7fa42227e3765$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$41d7fa42227e3765$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($41d7fa42227e3765$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$41d7fa42227e3765$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $41d7fa42227e3765$var$createBuffer(length) {
    if (length > $41d7fa42227e3765$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $41d7fa42227e3765$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $41d7fa42227e3765$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $41d7fa42227e3765$var$allocUnsafe(arg);
    }
    return $41d7fa42227e3765$var$from(arg, encodingOrOffset, length);
}
$41d7fa42227e3765$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $41d7fa42227e3765$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $41d7fa42227e3765$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $41d7fa42227e3765$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($41d7fa42227e3765$var$isInstance(value, ArrayBuffer) || value && $41d7fa42227e3765$var$isInstance(value.buffer, ArrayBuffer)) return $41d7fa42227e3765$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($41d7fa42227e3765$var$isInstance(value, SharedArrayBuffer) || value && $41d7fa42227e3765$var$isInstance(value.buffer, SharedArrayBuffer))) return $41d7fa42227e3765$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $41d7fa42227e3765$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $41d7fa42227e3765$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $41d7fa42227e3765$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $41d7fa42227e3765$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $41d7fa42227e3765$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($41d7fa42227e3765$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($41d7fa42227e3765$var$Buffer, Uint8Array);
function $41d7fa42227e3765$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $41d7fa42227e3765$var$alloc(size, fill, encoding) {
    $41d7fa42227e3765$var$assertSize(size);
    if (size <= 0) return $41d7fa42227e3765$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $41d7fa42227e3765$var$createBuffer(size).fill(fill, encoding) : $41d7fa42227e3765$var$createBuffer(size).fill(fill);
    return $41d7fa42227e3765$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $41d7fa42227e3765$var$Buffer.alloc = function(size, fill, encoding) {
    return $41d7fa42227e3765$var$alloc(size, fill, encoding);
};
function $41d7fa42227e3765$var$allocUnsafe(size) {
    $41d7fa42227e3765$var$assertSize(size);
    return $41d7fa42227e3765$var$createBuffer(size < 0 ? 0 : $41d7fa42227e3765$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $41d7fa42227e3765$var$Buffer.allocUnsafe = function(size) {
    return $41d7fa42227e3765$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $41d7fa42227e3765$var$Buffer.allocUnsafeSlow = function(size) {
    return $41d7fa42227e3765$var$allocUnsafe(size);
};
function $41d7fa42227e3765$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$41d7fa42227e3765$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $41d7fa42227e3765$var$byteLength(string, encoding) | 0;
    let buf = $41d7fa42227e3765$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $41d7fa42227e3765$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $41d7fa42227e3765$var$checked(array.length) | 0;
    const buf = $41d7fa42227e3765$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $41d7fa42227e3765$var$fromArrayView(arrayView) {
    if ($41d7fa42227e3765$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $41d7fa42227e3765$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $41d7fa42227e3765$var$fromArrayLike(arrayView);
}
function $41d7fa42227e3765$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $41d7fa42227e3765$var$Buffer.prototype);
    return buf;
}
function $41d7fa42227e3765$var$fromObject(obj) {
    if ($41d7fa42227e3765$var$Buffer.isBuffer(obj)) {
        const len = $41d7fa42227e3765$var$checked(obj.length) | 0;
        const buf = $41d7fa42227e3765$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $41d7fa42227e3765$var$numberIsNaN(obj.length)) return $41d7fa42227e3765$var$createBuffer(0);
        return $41d7fa42227e3765$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $41d7fa42227e3765$var$fromArrayLike(obj.data);
}
function $41d7fa42227e3765$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $41d7fa42227e3765$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $41d7fa42227e3765$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $41d7fa42227e3765$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $41d7fa42227e3765$var$Buffer.alloc(+length);
}
$41d7fa42227e3765$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $41d7fa42227e3765$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$41d7fa42227e3765$var$Buffer.compare = function compare(a, b) {
    if ($41d7fa42227e3765$var$isInstance(a, Uint8Array)) a = $41d7fa42227e3765$var$Buffer.from(a, a.offset, a.byteLength);
    if ($41d7fa42227e3765$var$isInstance(b, Uint8Array)) b = $41d7fa42227e3765$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$41d7fa42227e3765$var$Buffer.isBuffer(a) || !$41d7fa42227e3765$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$41d7fa42227e3765$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$41d7fa42227e3765$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $41d7fa42227e3765$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $41d7fa42227e3765$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($41d7fa42227e3765$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$41d7fa42227e3765$var$Buffer.isBuffer(buf)) buf = $41d7fa42227e3765$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$41d7fa42227e3765$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $41d7fa42227e3765$var$byteLength(string, encoding) {
    if ($41d7fa42227e3765$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $41d7fa42227e3765$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $41d7fa42227e3765$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $41d7fa42227e3765$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $41d7fa42227e3765$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$41d7fa42227e3765$var$Buffer.byteLength = $41d7fa42227e3765$var$byteLength;
function $41d7fa42227e3765$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $41d7fa42227e3765$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $41d7fa42227e3765$var$utf8Slice(this, start, end);
        case 'ascii':
            return $41d7fa42227e3765$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $41d7fa42227e3765$var$latin1Slice(this, start, end);
        case 'base64':
            return $41d7fa42227e3765$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $41d7fa42227e3765$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$41d7fa42227e3765$var$Buffer.prototype._isBuffer = true;
function $41d7fa42227e3765$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$41d7fa42227e3765$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$41d7fa42227e3765$var$swap(this, i, i + 1);
    return this;
};
$41d7fa42227e3765$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $41d7fa42227e3765$var$swap(this, i, i + 3);
        $41d7fa42227e3765$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$41d7fa42227e3765$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $41d7fa42227e3765$var$swap(this, i, i + 7);
        $41d7fa42227e3765$var$swap(this, i + 1, i + 6);
        $41d7fa42227e3765$var$swap(this, i + 2, i + 5);
        $41d7fa42227e3765$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$41d7fa42227e3765$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $41d7fa42227e3765$var$utf8Slice(this, 0, length);
    return $41d7fa42227e3765$var$slowToString.apply(this, arguments);
};
$41d7fa42227e3765$var$Buffer.prototype.toLocaleString = $41d7fa42227e3765$var$Buffer.prototype.toString;
$41d7fa42227e3765$var$Buffer.prototype.equals = function equals(b) {
    if (!$41d7fa42227e3765$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $41d7fa42227e3765$var$Buffer.compare(this, b) === 0;
};
$41d7fa42227e3765$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $41d7fa42227e3765$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($41d7fa42227e3765$var$customInspectSymbol) $41d7fa42227e3765$var$Buffer.prototype[$41d7fa42227e3765$var$customInspectSymbol] = $41d7fa42227e3765$var$Buffer.prototype.inspect;
$41d7fa42227e3765$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($41d7fa42227e3765$var$isInstance(target, Uint8Array)) target = $41d7fa42227e3765$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$41d7fa42227e3765$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $41d7fa42227e3765$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($41d7fa42227e3765$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $41d7fa42227e3765$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($41d7fa42227e3765$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $41d7fa42227e3765$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $41d7fa42227e3765$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $41d7fa42227e3765$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$41d7fa42227e3765$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$41d7fa42227e3765$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $41d7fa42227e3765$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$41d7fa42227e3765$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $41d7fa42227e3765$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $41d7fa42227e3765$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($41d7fa42227e3765$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $41d7fa42227e3765$var$utf8Write(buf, string, offset, length) {
    return $41d7fa42227e3765$var$blitBuffer($41d7fa42227e3765$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $41d7fa42227e3765$var$asciiWrite(buf, string, offset, length) {
    return $41d7fa42227e3765$var$blitBuffer($41d7fa42227e3765$var$asciiToBytes(string), buf, offset, length);
}
function $41d7fa42227e3765$var$base64Write(buf, string, offset, length) {
    return $41d7fa42227e3765$var$blitBuffer($41d7fa42227e3765$var$base64ToBytes(string), buf, offset, length);
}
function $41d7fa42227e3765$var$ucs2Write(buf, string, offset, length) {
    return $41d7fa42227e3765$var$blitBuffer($41d7fa42227e3765$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$41d7fa42227e3765$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $41d7fa42227e3765$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $41d7fa42227e3765$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $41d7fa42227e3765$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $41d7fa42227e3765$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $41d7fa42227e3765$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$41d7fa42227e3765$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $41d7fa42227e3765$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7ab3a47c4ed68956$export$6100ba28696e12de(buf);
    else return $7ab3a47c4ed68956$export$6100ba28696e12de(buf.slice(start, end));
}
function $41d7fa42227e3765$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $41d7fa42227e3765$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $41d7fa42227e3765$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $41d7fa42227e3765$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $41d7fa42227e3765$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $41d7fa42227e3765$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $41d7fa42227e3765$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $41d7fa42227e3765$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $41d7fa42227e3765$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $41d7fa42227e3765$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $41d7fa42227e3765$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$41d7fa42227e3765$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $41d7fa42227e3765$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $41d7fa42227e3765$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$41d7fa42227e3765$var$Buffer.prototype.readUintLE = $41d7fa42227e3765$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$41d7fa42227e3765$var$Buffer.prototype.readUintBE = $41d7fa42227e3765$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$41d7fa42227e3765$var$Buffer.prototype.readUint8 = $41d7fa42227e3765$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$41d7fa42227e3765$var$Buffer.prototype.readUint16LE = $41d7fa42227e3765$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$41d7fa42227e3765$var$Buffer.prototype.readUint16BE = $41d7fa42227e3765$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$41d7fa42227e3765$var$Buffer.prototype.readUint32LE = $41d7fa42227e3765$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$41d7fa42227e3765$var$Buffer.prototype.readUint32BE = $41d7fa42227e3765$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$41d7fa42227e3765$var$Buffer.prototype.readBigUInt64LE = $41d7fa42227e3765$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $41d7fa42227e3765$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $41d7fa42227e3765$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$41d7fa42227e3765$var$Buffer.prototype.readBigUInt64BE = $41d7fa42227e3765$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $41d7fa42227e3765$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $41d7fa42227e3765$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$41d7fa42227e3765$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$41d7fa42227e3765$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$41d7fa42227e3765$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$41d7fa42227e3765$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$41d7fa42227e3765$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$41d7fa42227e3765$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$41d7fa42227e3765$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$41d7fa42227e3765$var$Buffer.prototype.readBigInt64LE = $41d7fa42227e3765$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $41d7fa42227e3765$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $41d7fa42227e3765$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$41d7fa42227e3765$var$Buffer.prototype.readBigInt64BE = $41d7fa42227e3765$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $41d7fa42227e3765$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $41d7fa42227e3765$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$41d7fa42227e3765$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 4, this.length);
    return $9e5150a7da551dd2$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$41d7fa42227e3765$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 4, this.length);
    return $9e5150a7da551dd2$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$41d7fa42227e3765$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 8, this.length);
    return $9e5150a7da551dd2$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$41d7fa42227e3765$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkOffset(offset, 8, this.length);
    return $9e5150a7da551dd2$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $41d7fa42227e3765$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$41d7fa42227e3765$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$41d7fa42227e3765$var$Buffer.prototype.writeUintLE = $41d7fa42227e3765$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $41d7fa42227e3765$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$41d7fa42227e3765$var$Buffer.prototype.writeUintBE = $41d7fa42227e3765$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $41d7fa42227e3765$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$41d7fa42227e3765$var$Buffer.prototype.writeUint8 = $41d7fa42227e3765$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$41d7fa42227e3765$var$Buffer.prototype.writeUint16LE = $41d7fa42227e3765$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$41d7fa42227e3765$var$Buffer.prototype.writeUint16BE = $41d7fa42227e3765$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$41d7fa42227e3765$var$Buffer.prototype.writeUint32LE = $41d7fa42227e3765$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$41d7fa42227e3765$var$Buffer.prototype.writeUint32BE = $41d7fa42227e3765$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $41d7fa42227e3765$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $41d7fa42227e3765$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $41d7fa42227e3765$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $41d7fa42227e3765$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$41d7fa42227e3765$var$Buffer.prototype.writeBigUInt64LE = $41d7fa42227e3765$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $41d7fa42227e3765$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$41d7fa42227e3765$var$Buffer.prototype.writeBigUInt64BE = $41d7fa42227e3765$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $41d7fa42227e3765$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$41d7fa42227e3765$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $41d7fa42227e3765$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$41d7fa42227e3765$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $41d7fa42227e3765$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$41d7fa42227e3765$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$41d7fa42227e3765$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$41d7fa42227e3765$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$41d7fa42227e3765$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$41d7fa42227e3765$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$41d7fa42227e3765$var$Buffer.prototype.writeBigInt64LE = $41d7fa42227e3765$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $41d7fa42227e3765$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$41d7fa42227e3765$var$Buffer.prototype.writeBigInt64BE = $41d7fa42227e3765$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $41d7fa42227e3765$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $41d7fa42227e3765$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $41d7fa42227e3765$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9e5150a7da551dd2$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$41d7fa42227e3765$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $41d7fa42227e3765$var$writeFloat(this, value, offset, true, noAssert);
};
$41d7fa42227e3765$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $41d7fa42227e3765$var$writeFloat(this, value, offset, false, noAssert);
};
function $41d7fa42227e3765$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41d7fa42227e3765$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9e5150a7da551dd2$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$41d7fa42227e3765$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $41d7fa42227e3765$var$writeDouble(this, value, offset, true, noAssert);
};
$41d7fa42227e3765$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $41d7fa42227e3765$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$41d7fa42227e3765$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$41d7fa42227e3765$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$41d7fa42227e3765$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$41d7fa42227e3765$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $41d7fa42227e3765$var$Buffer.isBuffer(val) ? val : $41d7fa42227e3765$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $41d7fa42227e3765$var$errors = {};
function $41d7fa42227e3765$var$E(sym, getMessage, Base) {
    $41d7fa42227e3765$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$41d7fa42227e3765$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$41d7fa42227e3765$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$41d7fa42227e3765$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $41d7fa42227e3765$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $41d7fa42227e3765$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $41d7fa42227e3765$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $41d7fa42227e3765$var$checkBounds(buf, offset, byteLength) {
    $41d7fa42227e3765$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $41d7fa42227e3765$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $41d7fa42227e3765$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $41d7fa42227e3765$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $41d7fa42227e3765$var$checkBounds(buf, offset, byteLength);
}
function $41d7fa42227e3765$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $41d7fa42227e3765$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $41d7fa42227e3765$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $41d7fa42227e3765$var$validateNumber(value, type);
        throw new $41d7fa42227e3765$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $41d7fa42227e3765$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $41d7fa42227e3765$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $41d7fa42227e3765$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $41d7fa42227e3765$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($41d7fa42227e3765$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $41d7fa42227e3765$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $41d7fa42227e3765$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $41d7fa42227e3765$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $41d7fa42227e3765$var$base64ToBytes(str) {
    return $7ab3a47c4ed68956$export$d622b2ad8d90c771($41d7fa42227e3765$var$base64clean(str));
}
function $41d7fa42227e3765$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $41d7fa42227e3765$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $41d7fa42227e3765$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $41d7fa42227e3765$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $41d7fa42227e3765$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $41d7fa42227e3765$var$BufferBigIntNotDefined : fn;
}
function $41d7fa42227e3765$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $b21a8622f171bfee$require$Buffer = $41d7fa42227e3765$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $b21a8622f171bfee$var$isVisitable(thing) {
    return (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $b21a8622f171bfee$var$removeBrackets(key) {
    return (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $b21a8622f171bfee$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $b21a8622f171bfee$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $b21a8622f171bfee$var$isFlatArray(arr) {
    return (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(arr) && !arr.some($b21a8622f171bfee$var$isVisitable);
}
const $b21a8622f171bfee$var$predicates = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).toFlatObject((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $b21a8622f171bfee$var$toFormData(obj, formData, options) {
    if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $52b1b290f9a96c53$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $b21a8622f171bfee$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isReactNative(formData) && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($b21a8622f171bfee$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(value) && $b21a8622f171bfee$var$isFlatArray(value) || ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFileList(value) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $b21a8622f171bfee$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $b21a8622f171bfee$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($b21a8622f171bfee$var$isVisitable(value)) return true;
        formData.append($b21a8622f171bfee$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($b21a8622f171bfee$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $b21a8622f171bfee$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $b21a8622f171bfee$export$2e2bcd8739ae039 = $b21a8622f171bfee$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $98bc44a3a8bee66e$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $98bc44a3a8bee66e$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $b21a8622f171bfee$export$2e2bcd8739ae039)(params, this, options);
}
const $98bc44a3a8bee66e$var$prototype = $98bc44a3a8bee66e$var$AxiosURLSearchParams.prototype;
$98bc44a3a8bee66e$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$98bc44a3a8bee66e$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $98bc44a3a8bee66e$var$encode);
    } : $98bc44a3a8bee66e$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $98bc44a3a8bee66e$export$2e2bcd8739ae039 = $98bc44a3a8bee66e$var$AxiosURLSearchParams;


'use strict';
function $aa479b01e808fbf1$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $aa479b01e808fbf1$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $aa479b01e808fbf1$export$c564cdbbe6da493;
    const _options = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $98bc44a3a8bee66e$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $2da962861082343e$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $2da962861082343e$export$2e2bcd8739ae039 = $2da962861082343e$var$InterceptorManager;





'use strict';
var $1bccd34118f001e9$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $c0ac30df3346ac96$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $98bc44a3a8bee66e$export$2e2bcd8739ae039);


'use strict';
var $ff201a2a9ae37ad4$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $455c9d8cbd6311d4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $ff030378212afe39$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $c0ac30df3346ac96$export$2e2bcd8739ae039,
        FormData: $ff201a2a9ae37ad4$export$2e2bcd8739ae039,
        Blob: $455c9d8cbd6311d4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $0b6e49eb843295c5$exports = {};

$parcel$export($0b6e49eb843295c5$exports, "hasBrowserEnv", function () { return $0b6e49eb843295c5$export$c4996c4b7b93b0bf; });
$parcel$export($0b6e49eb843295c5$exports, "navigator", function () { return $0b6e49eb843295c5$export$ec7c8efa7f5790ae; });
$parcel$export($0b6e49eb843295c5$exports, "hasStandardBrowserEnv", function () { return $0b6e49eb843295c5$export$c0bcc9250309d66; });
$parcel$export($0b6e49eb843295c5$exports, "hasStandardBrowserWebWorkerEnv", function () { return $0b6e49eb843295c5$export$c81692cf5af97dac; });
$parcel$export($0b6e49eb843295c5$exports, "origin", function () { return $0b6e49eb843295c5$export$f710a83a91838a36; });
const $0b6e49eb843295c5$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $0b6e49eb843295c5$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $0b6e49eb843295c5$export$c0bcc9250309d66 = $0b6e49eb843295c5$export$c4996c4b7b93b0bf && (!$0b6e49eb843295c5$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($0b6e49eb843295c5$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $0b6e49eb843295c5$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $0b6e49eb843295c5$export$f710a83a91838a36 = $0b6e49eb843295c5$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $41688f95bcd9179c$export$2e2bcd8739ae039 = {
    ...$0b6e49eb843295c5$exports,
    ...(0, $ff030378212afe39$export$2e2bcd8739ae039)
};


'use strict';
function $dd64084225c94008$export$2e2bcd8739ae039(data, options) {
    return (0, $b21a8622f171bfee$export$2e2bcd8739ae039)(data, new (0, $41688f95bcd9179c$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $41688f95bcd9179c$export$2e2bcd8739ae039).isNode && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $33d4283bfd8fd102$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $33d4283bfd8fd102$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $33d4283bfd8fd102$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $33d4283bfd8fd102$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFormData(formData) && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($33d4283bfd8fd102$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $33d4283bfd8fd102$export$2e2bcd8739ae039 = $33d4283bfd8fd102$var$formDataToJSON;


'use strict';
const $a85b2316329d5a0d$var$own = (obj, key)=>obj != null && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a85b2316329d5a0d$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a85b2316329d5a0d$var$defaults = {
    transitional: (0, $1bccd34118f001e9$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $33d4283bfd8fd102$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isBuffer(data) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isStream(data) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFile(data) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isBlob(data) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $a85b2316329d5a0d$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $dd64084225c94008$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $a85b2316329d5a0d$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $b21a8622f171bfee$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a85b2316329d5a0d$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $a85b2316329d5a0d$var$own(this, 'transitional') || $a85b2316329d5a0d$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $a85b2316329d5a0d$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isResponse(data) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $a85b2316329d5a0d$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $5f470fdf41780c75$export$2e2bcd8739ae039).from(e, (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $a85b2316329d5a0d$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $41688f95bcd9179c$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $41688f95bcd9179c$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $a85b2316329d5a0d$var$defaults.headers[method] = {};
});
var $a85b2316329d5a0d$export$2e2bcd8739ae039 = $a85b2316329d5a0d$var$defaults;



'use strict';
function $a149f6b154b5c0de$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $a85b2316329d5a0d$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $54d294f46ebe052d$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $2013ee3f7b62e159$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $9e09df9bd8e627fd$var$CanceledError extends (0, $5f470fdf41780c75$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9e09df9bd8e627fd$export$2e2bcd8739ae039 = $9e09df9bd8e627fd$var$CanceledError;







'use strict';
function $6b96d15c2129f790$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $ae8fbe6f36ccf9d5$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $97dfb029451abc3b$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $97dfb029451abc3b$export$2e2bcd8739ae039 = $97dfb029451abc3b$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $4f2740cf6bee7dd2$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $4f2740cf6bee7dd2$export$2e2bcd8739ae039 = $4f2740cf6bee7dd2$var$throttle;



const $0517544144fb4226$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $97dfb029451abc3b$export$2e2bcd8739ae039)(50, 250);
    return (0, $4f2740cf6bee7dd2$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $0517544144fb4226$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $0517544144fb4226$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $d8feb3cf9c8e5a3f$export$2e2bcd8739ae039 = (0, $41688f95bcd9179c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $41688f95bcd9179c$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $41688f95bcd9179c$export$2e2bcd8739ae039).origin), (0, $41688f95bcd9179c$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $41688f95bcd9179c$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $20218c72a37cf6fc$export$2e2bcd8739ae039 = (0, $41688f95bcd9179c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $d5e4af9f8e60efa3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $e00b51db30fa9e36$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $011b8334fd4eb488$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $d5e4af9f8e60efa3$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $e00b51db30fa9e36$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $142df61ddd0397ef$var$headersToObject = (thing)=>thing instanceof (0, $54d294f46ebe052d$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $142df61ddd0397ef$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isPlainObject(target) && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($142df61ddd0397ef$var$headersToObject(a), $142df61ddd0397ef$var$headersToObject(b), prop, true)
    };
    (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




const $99ba159311c109a7$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $99ba159311c109a7$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($99ba159311c109a7$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $99ba159311c109a7$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
var $99ba159311c109a7$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $142df61ddd0397ef$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $54d294f46ebe052d$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $aa479b01e808fbf1$export$2e2bcd8739ae039)((0, $011b8334fd4eb488$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $99ba159311c109a7$var$encodeUTF8(auth.password) : '')));
    if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $41688f95bcd9179c$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $41688f95bcd9179c$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $99ba159311c109a7$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $41688f95bcd9179c$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $d8feb3cf9c8e5a3f$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $20218c72a37cf6fc$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};



const $d60b885e99de864e$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $d60b885e99de864e$export$2e2bcd8739ae039 = $d60b885e99de864e$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $99ba159311c109a7$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $54d294f46ebe052d$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $54d294f46ebe052d$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $6b96d15c2129f790$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('Request aborted', (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)(msg, (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $1bccd34118f001e9$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ETIMEDOUT : (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach((0, $3f8a3fa449b65873$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $0517544144fb4226$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $0517544144fb4226$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9e09df9bd8e627fd$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $ae8fbe6f36ccf9d5$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $41688f95bcd9179c$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a46bb76cca839b7e$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $5f470fdf41780c75$export$2e2bcd8739ae039) ? err : new (0, $9e09df9bd8e627fd$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $a46bb76cca839b7e$export$2e2bcd8739ae039 = $a46bb76cca839b7e$var$composeSignals;


const $5e56780005a81c89$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $5e56780005a81c89$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $5e56780005a81c89$var$readStream(iterable))yield* $5e56780005a81c89$export$71b051935044bd5d(chunk, chunkSize);
};
const $5e56780005a81c89$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $5e56780005a81c89$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $5e56780005a81c89$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $1aa616d10d61b0d1$require$Buffer = $41d7fa42227e3765$export$a143d493d941bafc;
function $1aa616d10d61b0d1$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $1aa616d10d61b0d1$require$Buffer !== 'undefined' && typeof $1aa616d10d61b0d1$require$Buffer.byteLength === 'function') return $1aa616d10d61b0d1$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $8aa9282a35a8f02b$export$a4ad2735b021c132 = "1.16.1";



const $17a984a62e25e26c$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $17a984a62e25e26c$var$isFunction } = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039);
const $17a984a62e25e26c$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $17a984a62e25e26c$var$factory = (env)=>{
    const globalObject = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).global !== undefined && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).global !== null ? (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $17a984a62e25e26c$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $17a984a62e25e26c$var$isFunction(Request);
    const isResponseSupported = $17a984a62e25e26c$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $17a984a62e25e26c$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $17a984a62e25e26c$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $41688f95bcd9179c$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $17a984a62e25e26c$var$test(()=>(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $41688f95bcd9179c$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $99ba159311c109a7$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a46bb76cca839b7e$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $1aa616d10d61b0d1$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against the outbound request body before dispatch.
            // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
            // maxBodyLength limit'). Skip when the body length cannot be determined
            // (e.g. a live ReadableStream supplied by the caller).
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await resolveBodyLength(headers, data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
            }
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $0517544144fb4226$export$d9fadd12586c18d6)(requestContentLength, (0, $0517544144fb4226$export$c1b28109d46c3592)((0, $0517544144fb4226$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $5e56780005a81c89$export$b0119225647bd83)(_request.body, $17a984a62e25e26c$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $8aa9282a35a8f02b$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $3f8a3fa449b65873$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $0517544144fb4226$export$d9fadd12586c18d6)(responseContentLength, (0, $0517544144fb4226$export$c1b28109d46c3592)((0, $0517544144fb4226$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $5e56780005a81c89$export$b0119225647bd83)(response.body, $17a984a62e25e26c$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $6b96d15c2129f790$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $54d294f46ebe052d$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $5f470fdf41780c75$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('Network Error', (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $5f470fdf41780c75$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $17a984a62e25e26c$var$seedCache = new Map();
const $17a984a62e25e26c$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $17a984a62e25e26c$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $17a984a62e25e26c$var$factory(env));
        map = target;
    }
    return target;
};
const $17a984a62e25e26c$var$adapter = $17a984a62e25e26c$export$3105c6651375d4fa();
var $17a984a62e25e26c$export$2e2bcd8739ae039 = $17a984a62e25e26c$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $6408f9eca4e18266$var$knownAdapters = {
    http: (0, $52b1b290f9a96c53$export$2e2bcd8739ae039),
    xhr: (0, $d60b885e99de864e$export$2e2bcd8739ae039),
    fetch: {
        get: $17a984a62e25e26c$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach($6408f9eca4e18266$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $6408f9eca4e18266$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $6408f9eca4e18266$var$isResolvedHandle = (adapter)=>(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $6408f9eca4e18266$var$getAdapter(adapters, config) {
    adapters = (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$6408f9eca4e18266$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $6408f9eca4e18266$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($6408f9eca4e18266$var$renderReason).join('\n') : ' ' + $6408f9eca4e18266$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $6408f9eca4e18266$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $6408f9eca4e18266$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $6408f9eca4e18266$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $f19dc2d47e061113$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9e09df9bd8e627fd$export$2e2bcd8739ae039)(null, config);
}
function $f19dc2d47e061113$export$2e2bcd8739ae039(config) {
    $f19dc2d47e061113$var$throwIfCancellationRequested(config);
    config.headers = (0, $54d294f46ebe052d$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $a149f6b154b5c0de$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $6408f9eca4e18266$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $a85b2316329d5a0d$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $f19dc2d47e061113$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $a149f6b154b5c0de$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $54d294f46ebe052d$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $2013ee3f7b62e159$export$2e2bcd8739ae039)(reason)) {
            $f19dc2d47e061113$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $a149f6b154b5c0de$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $54d294f46ebe052d$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $1b5fff9ab3d21e34$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1b5fff9ab3d21e34$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1b5fff9ab3d21e34$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1b5fff9ab3d21e34$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $8aa9282a35a8f02b$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$1b5fff9ab3d21e34$var$deprecatedWarnings[opt]) {
            $1b5fff9ab3d21e34$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1b5fff9ab3d21e34$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1b5fff9ab3d21e34$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('options must be an object', (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $5f470fdf41780c75$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $5f470fdf41780c75$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $1b5fff9ab3d21e34$export$2e2bcd8739ae039 = {
    assertOptions: $1b5fff9ab3d21e34$var$assertOptions,
    validators: $1b5fff9ab3d21e34$var$validators
};




'use strict';
const $0c9aa15ac776ab0b$var$validators = (0, $1b5fff9ab3d21e34$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $0c9aa15ac776ab0b$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $2da962861082343e$export$2e2bcd8739ae039)(),
            response: new (0, $2da962861082343e$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $142df61ddd0397ef$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1b5fff9ab3d21e34$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $0c9aa15ac776ab0b$var$validators.transitional($0c9aa15ac776ab0b$var$validators.boolean),
            forcedJSONParsing: $0c9aa15ac776ab0b$var$validators.transitional($0c9aa15ac776ab0b$var$validators.boolean),
            clarifyTimeoutError: $0c9aa15ac776ab0b$var$validators.transitional($0c9aa15ac776ab0b$var$validators.boolean),
            legacyInterceptorReqResOrdering: $0c9aa15ac776ab0b$var$validators.transitional($0c9aa15ac776ab0b$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1b5fff9ab3d21e34$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $0c9aa15ac776ab0b$var$validators.function,
                serialize: $0c9aa15ac776ab0b$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $1b5fff9ab3d21e34$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $0c9aa15ac776ab0b$var$validators.spelling('baseURL'),
            withXsrfToken: $0c9aa15ac776ab0b$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $54d294f46ebe052d$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $1bccd34118f001e9$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $f19dc2d47e061113$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $f19dc2d47e061113$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $142df61ddd0397ef$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $011b8334fd4eb488$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $aa479b01e808fbf1$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $0c9aa15ac776ab0b$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $142df61ddd0397ef$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $142df61ddd0397ef$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $0c9aa15ac776ab0b$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $0c9aa15ac776ab0b$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $0c9aa15ac776ab0b$export$2e2bcd8739ae039 = $0c9aa15ac776ab0b$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $7a680748e155dc3b$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9e09df9bd8e627fd$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $7a680748e155dc3b$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $7a680748e155dc3b$export$2e2bcd8739ae039 = $7a680748e155dc3b$var$CancelToken;






'use strict';
function $803cea8a87d15230$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $de2a483130ca2857$export$2e2bcd8739ae039(payload) {
    return (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $0dc2b8512f7ea5b9$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($0dc2b8512f7ea5b9$var$HttpStatusCode).forEach(([key, value])=>{
    $0dc2b8512f7ea5b9$var$HttpStatusCode[value] = key;
});
var $0dc2b8512f7ea5b9$export$2e2bcd8739ae039 = $0dc2b8512f7ea5b9$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $7ab954312ef88736$var$createInstance(defaultConfig) {
    const context = new (0, $0c9aa15ac776ab0b$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $cfc6b7689f4adcdd$export$2e2bcd8739ae039)((0, $0c9aa15ac776ab0b$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).extend(instance, (0, $0c9aa15ac776ab0b$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $7ab954312ef88736$var$createInstance((0, $142df61ddd0397ef$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $7ab954312ef88736$var$axios = $7ab954312ef88736$var$createInstance((0, $a85b2316329d5a0d$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$7ab954312ef88736$var$axios.Axios = (0, $0c9aa15ac776ab0b$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$7ab954312ef88736$var$axios.CanceledError = (0, $9e09df9bd8e627fd$export$2e2bcd8739ae039);
$7ab954312ef88736$var$axios.CancelToken = (0, $7a680748e155dc3b$export$2e2bcd8739ae039);
$7ab954312ef88736$var$axios.isCancel = (0, $2013ee3f7b62e159$export$2e2bcd8739ae039);
$7ab954312ef88736$var$axios.VERSION = (0, $8aa9282a35a8f02b$export$a4ad2735b021c132);
$7ab954312ef88736$var$axios.toFormData = (0, $b21a8622f171bfee$export$2e2bcd8739ae039);
// Expose AxiosError class
$7ab954312ef88736$var$axios.AxiosError = (0, $5f470fdf41780c75$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$7ab954312ef88736$var$axios.Cancel = $7ab954312ef88736$var$axios.CanceledError;
// Expose all/spread
$7ab954312ef88736$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$7ab954312ef88736$var$axios.spread = (0, $803cea8a87d15230$export$2e2bcd8739ae039);
// Expose isAxiosError
$7ab954312ef88736$var$axios.isAxiosError = (0, $de2a483130ca2857$export$2e2bcd8739ae039);
// Expose mergeConfig
$7ab954312ef88736$var$axios.mergeConfig = (0, $142df61ddd0397ef$export$2e2bcd8739ae039);
$7ab954312ef88736$var$axios.AxiosHeaders = (0, $54d294f46ebe052d$export$2e2bcd8739ae039);
$7ab954312ef88736$var$axios.formToJSON = (thing)=>(0, $33d4283bfd8fd102$export$2e2bcd8739ae039)((0, $ff8c5b784cd951b0$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$7ab954312ef88736$var$axios.getAdapter = (0, $6408f9eca4e18266$export$2e2bcd8739ae039).getAdapter;
$7ab954312ef88736$var$axios.HttpStatusCode = (0, $0dc2b8512f7ea5b9$export$2e2bcd8739ae039);
$7ab954312ef88736$var$axios.default = $7ab954312ef88736$var$axios;
var // this module should only have a default export
$7ab954312ef88736$export$2e2bcd8739ae039 = $7ab954312ef88736$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $875f0905365ce8e6$export$1c00760e9e5a4e95, AxiosError: $875f0905365ce8e6$export$c1fbed17c2f6a328, CanceledError: $875f0905365ce8e6$export$1ab0c6b20d94fa14, isCancel: $875f0905365ce8e6$export$3b22524397b493c6, CancelToken: $875f0905365ce8e6$export$fd08e3cb425f0d61, VERSION: $875f0905365ce8e6$export$a4ad2735b021c132, all: $875f0905365ce8e6$export$84bf76cd7afc7469, Cancel: $875f0905365ce8e6$export$848c9b7ead0df967, isAxiosError: $875f0905365ce8e6$export$fbafdbe06a5b5a9a, spread: $875f0905365ce8e6$export$3ae0fd4797ed47c8, toFormData: $875f0905365ce8e6$export$10ae0d317ea97f8b, AxiosHeaders: $875f0905365ce8e6$export$4e7d6ff0f3e6520, HttpStatusCode: $875f0905365ce8e6$export$a972f69c851492b3, formToJSON: $875f0905365ce8e6$export$86d7c59254d6a2c9, getAdapter: $875f0905365ce8e6$export$17ddc20a97d669e2, mergeConfig: $875f0905365ce8e6$export$7ec1ebcfa9d8bd6a, create: $875f0905365ce8e6$export$185802fd694ee1f5 } = (0, $7ab954312ef88736$export$2e2bcd8739ae039);


var $eb8625b45480c82f$export$2e2bcd8739ae039 = new class {
    #envRoutes;
    #promise;
    constructor(){
        this.#promise = (0, $7ab954312ef88736$export$2e2bcd8739ae039).get("/routes.json").then((response)=>{
            this.#envRoutes = response.data;
        });
    }
    async getRoutes() {
        if (!this.#envRoutes) await this.#promise;
        if (!this.#envRoutes) throw new Error("Routes not loaded");
        return this.#envRoutes;
    }
}();



"use strict";
class $3f5562669bbab970$export$5087227eb54526 {
    #events = {};
    constructor(){
        this.#events = {};
    }
    subscribe(event, callback) {
        if (!this.#events[event]) this.#events[event] = [];
        this.#events[event].push(callback);
    }
    publish(event, data) {
        if (!this.#events[event]) return;
        this.#events[event].forEach((callback)=>callback(data));
    }
}



"use strict";
class $10e2be3093933457$export$79dd73309e90dfd0 {
    constructor(eventBus){
        eventBus.subscribe("login", this.afterLogin);
    }
    afterLogin = (data)=>{
        (0, $7ab954312ef88736$export$2e2bcd8739ae039).post(window.location.pathname + "/result", data).then((response)=>{
            if (response.status === 200) window.location.href = response.data.redirectUrl;
        });
    };
}


"use strict";
function $161f84352c1eb7fa$export$191b4c9edf0899a6() {
    document.getElementById("authenticatingUser").style.display = "block";
}
function $161f84352c1eb7fa$export$c6c09f9583388923() {
    document.getElementById("authenticatingUser").style.display = "none";
}
function $161f84352c1eb7fa$export$64858b67578a10bb() {
    document.getElementById("loading").style.display = "flex";
}
function $161f84352c1eb7fa$export$7d026bf51c574e0d() {
    document.getElementById("loading").style.display = "none";
}
function $161f84352c1eb7fa$export$1d1423934687e1c6() {
    $161f84352c1eb7fa$export$7d026bf51c574e0d();
    $161f84352c1eb7fa$export$c6c09f9583388923();
    document.getElementById("loginForm").style.display = "block";
    document.getElementById("logoContainer").children[0].style.display = "block";
    document.getElementById("signUpDiv").style.display = "block";
    document.getElementById("legalTermsSection").style.display = "block";
}


var $03a008e57426b866$exports = {};
$03a008e57426b866$exports = $parcel$resolve("km6Q2");


var $d644a2e113e7a9b3$exports = {};
$d644a2e113e7a9b3$exports = $parcel$resolve("dME4c");


var $27f17e0e06e41d97$exports = {};
$27f17e0e06e41d97$exports = $parcel$resolve("dGBNJ");


var $c51f741d7c4b72c5$exports = {};
$c51f741d7c4b72c5$exports = $parcel$resolve("aSdYY");


var $b47f6b0f371800d3$exports = {};
$b47f6b0f371800d3$exports = $parcel$resolve("kE6fw");


var $59a05e5548888bd6$exports = {};
$59a05e5548888bd6$exports = $parcel$resolve("9L4Ri");


var $22ecd0c291f7f48e$exports = {};
$22ecd0c291f7f48e$exports = $parcel$resolve("iZ4C6");


var $c6637c58df03779e$exports = {};
$c6637c58df03779e$exports = $parcel$resolve("gu0ON");


var $6cc3a35ebc8d678b$exports = {};
$6cc3a35ebc8d678b$exports = $parcel$resolve("chEZm");


var $462e7f44f8eafbb4$exports = {};
$462e7f44f8eafbb4$exports = $parcel$resolve("dmGOx");


var $bc0db72104fba2a4$exports = {};
$bc0db72104fba2a4$exports = $parcel$resolve("341Ay");


var $29ed0de9178d3fc0$exports = {};
$29ed0de9178d3fc0$exports = $parcel$resolve("hjiHz");


var $a99cada972d0f1e6$exports = {};
$a99cada972d0f1e6$exports = $parcel$resolve("c0Orn");


var $a4b9bdbb68cd673e$exports = {};
$a4b9bdbb68cd673e$exports = $parcel$resolve("l0n69");


var $70cedad54c00ad49$exports = {};
$70cedad54c00ad49$exports = $parcel$resolve("4Bnt4");


var $1d2002b68fdcabf7$exports = {};
$1d2002b68fdcabf7$exports = $parcel$resolve("dRHww");


var $97f2ebd491ea1c56$exports = {};
$97f2ebd491ea1c56$exports = $parcel$resolve("ekACy");


var $f5b3c73a633d2bb4$exports = {};
$f5b3c73a633d2bb4$exports = $parcel$resolve("lTqcR");


var $868461de1da1a260$exports = {};
$868461de1da1a260$exports = $parcel$resolve("1bGWL");


var $c4604ffb66eabc1e$exports = {};
$c4604ffb66eabc1e$exports = $parcel$resolve("gfAld");


var $1301127d4e43a2c5$exports = {};
$1301127d4e43a2c5$exports = $parcel$resolve("7pgXg");


var $070000135cf2724e$exports = {};
$070000135cf2724e$exports = $parcel$resolve("fiPpo");


var $239e337f52cd8b4d$exports = {};
$239e337f52cd8b4d$exports = $parcel$resolve("kUqTd");


var $16346f3b9680e038$exports = {};
$16346f3b9680e038$exports = $parcel$resolve("5Nbdb");


var $f23d1a9e60427824$exports = {};
$f23d1a9e60427824$exports = $parcel$resolve("7XRXC");


var $343fd1c9e7bd515a$exports = {};
$343fd1c9e7bd515a$exports = $parcel$resolve("iFLSi");


var $c3f84942cd8b75e6$exports = {};
$c3f84942cd8b75e6$exports = $parcel$resolve("aeul6");


var $d986c59897a4c052$exports = {};
$d986c59897a4c052$exports = $parcel$resolve("lDv8g");


// console.log(documen)
/*
 * This code is to test the document referrer and build out the logo switching
 */ let $31691340282c7066$var$isStaging = false;
// Check if we're in staging environment and automatically enable the forgot password button and hide captcha
async function $31691340282c7066$var$checkEnvironment() {
    try {
        const routes = await (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes();
        $31691340282c7066$var$isStaging = routes.backendAuthServer && routes.backendAuthServer.includes("staging");
        if ($31691340282c7066$var$isStaging) {
            if (document.getElementById("forgotPwBtn")) document.getElementById("forgotPwBtn").disabled = false;
            if (document.getElementById("captchaContainer")) document.getElementById("captchaContainer").style.display = "none";
        }
    } catch (error) {
        console.error("Error determining environment:", error);
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    $31691340282c7066$var$checkEnvironment();
});
const $31691340282c7066$var$eventBus = new (0, $3f5562669bbab970$export$5087227eb54526)();
const $31691340282c7066$var$MOBILE_REDIRECT_ROUTE = "/mobileDashboard";
const $31691340282c7066$var$USE_NEW_PW_EXPIRED = true;
const $31691340282c7066$var$isESignatureVerification = window.location.pathname === "/esignature-verification";
const $31691340282c7066$var$isOAuth = window.location.pathname.includes("/interaction");
if ($31691340282c7066$var$isOAuth) new (0, $10e2be3093933457$export$79dd73309e90dfd0)($31691340282c7066$var$eventBus);
// This is a workaround for SSO logins. I don't have access to the
// cookies from the ssoLogin route, so we send the user back here
// and check if they are already logged in, then run the OIDC flow.
if (window.location.search.includes("checkLoggedIn=true")) (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes().then((routes)=>{
    (0, $7ab954312ef88736$export$2e2bcd8739ae039).post(`${routes.backendAuthServer}/verify`).then((response)=>{
        console.log("devLog: response", response);
        if (response.data.success) $31691340282c7066$var$eventBus.publish("login", {
            success: true,
            user: response.data.userID,
            username: response.data.userLoginName
        });
    }).catch((error)=>{
        console.error("devLog: error", error);
    });
});
document.getElementById("loginBtn").addEventListener("click", function() {
    $31691340282c7066$var$submitLogin();
});
document.getElementById("loginForm").addEventListener("keydown", function(event) {
    if (event.key == "Enter") $31691340282c7066$var$submitLogin();
}, false);
document.getElementById("forgotPwBtn").addEventListener("click", function() {
    $31691340282c7066$var$forgotMyPassword();
});
/*

   On page load we should check for the exsitance of a cookie and redirect the user if they have one? Maybe.

*/ let $31691340282c7066$var$userField = "system_processor"; //these names are specifically misleading
let $31691340282c7066$var$passField = "limble_region"; //these names are specifically misleading
let $31691340282c7066$var$creds = $31691340282c7066$var$getLoginLocalStorage($31691340282c7066$var$userField, $31691340282c7066$var$passField);
if ($31691340282c7066$var$creds.user && $31691340282c7066$var$creds.pass) {
    document.getElementById("username").value = $31691340282c7066$var$creds.user;
    document.getElementById("password").value = $31691340282c7066$var$creds.pass;
    document.getElementById("box3").checked = true;
}
function $31691340282c7066$var$submitLogin() {
    //IN THE FUTURE BEFORE WE POST TO THE LOGIN SERVER WILL NEED TO POST TO THE AUTH SERVER LOCATED IN N.CALI
    //THAT AUTH SERVER WILL HAVE TO RETURN WHICH REGION THE ACCOUNT IS IN BASED ON A HASH DATABASE/Dynamo
    // grecaptcha.ready(function () {
    //    grecaptcha
    //       .execute("6LeyXOAUAAAAAIEfLKdFbTscOgqtl34_M1cSWK09", { action: "login" })
    //       .then(function (token) {
    if (document.getElementById("username").value && document.getElementById("password").value) $31691340282c7066$var$login();
    else {
        document.getElementById("loginErr").style.display = "";
        document.getElementById("loading").style.display = "none";
        $31691340282c7066$var$setAllLogoDisplays("");
        return;
    }
// });
// });
}
async function $31691340282c7066$var$submitPasswordUpdate() {
    $31691340282c7066$var$setAllLogoDisplays("none");
    document.getElementById("loading").style.display = "flex";
    try {
        const validCurrentPassword = await $31691340282c7066$var$verifyCurrentPassword();
        if (validCurrentPassword) {
            const updateSuccessful = await $31691340282c7066$var$updatePassword();
            if (updateSuccessful) $31691340282c7066$var$showUpdateSuccess();
            else $31691340282c7066$var$showUpdateError();
        } else $31691340282c7066$var$showCurrentPasswordValidationError();
    } catch (error) {
        $31691340282c7066$var$showUpdateError();
    } finally{
        document.getElementById("loading").style.display = "none";
        $31691340282c7066$var$setAllLogoDisplays("");
    }
}
function $31691340282c7066$var$setAllLogoDisplays(displayCode = "") {
    var logos = document.getElementsByClassName("logo");
    for(var i = 0; i < logos.length; ++i){
        var item = logos[i];
        item.style.display = displayCode;
    }
}
async function $31691340282c7066$var$verifyCurrentPassword() {
    try {
        const routes = await (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes();
        let config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        const response = await (0, $7ab954312ef88736$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/verifyCurrentPassword", {
            username: document.getElementById("username").value,
            currentPassword: document.getElementById("currentPassword").value
        }, config);
        return response.data.success;
    } catch (error) {
        return false;
    }
}
async function $31691340282c7066$var$updatePassword() {
    try {
        const routes = await (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes();
        let config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        const response = await (0, $7ab954312ef88736$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/updatePassword", {
            username: document.getElementById("username").value,
            currentPassword: document.getElementById("currentPassword").value,
            newPassword: document.getElementById("newPassword").value,
            confirmNewPassword: document.getElementById("confirmNewPass").value
        }, config);
        return response?.data?.success ? true : false;
    } catch (error) {
        return false;
    }
}
function $31691340282c7066$var$showUpdateSuccess() {
    // Show the success message div
    const messageDiv = document.getElementById("updatePasswordMessage");
    messageDiv.style.display = "block";
    messageDiv.style.color = "#14AE5C";
    messageDiv.textContent = document.lang.PasswordSuccessfullyUpdatedLoginAgain;
    // Reset the form and show login
    document.getElementById("newPwExpired").style.display = "none";
    document.getElementById("loginForm").style.display = "";
    document.getElementById("signUpDiv").style.display = "";
    document.getElementById("legalTermsSection").style.display = "";
    // Clear the password fields
    document.getElementById("password").value = "";
    document.getElementById("currentPassword").value = "";
    document.getElementById("newPassword").value = "";
    document.getElementById("confirmNewPass").value = "";
}
function $31691340282c7066$var$showUpdateError() {
    const messageDiv = document.getElementById("updatePasswordMessage");
    messageDiv.style.display = "block";
    messageDiv.style.color = "#FF0000";
    messageDiv.textContent = document.lang.ErrorUpdatingPasswordContactSupport;
}
function $31691340282c7066$var$showCurrentPasswordValidationError() {
    const currentPasswordElement = document.getElementById("currentPassword");
    const errorElement = document.getElementById("currentPasswordFieldError");
    const wrapperElement = currentPasswordElement.closest(".wrap-input");
    errorElement.style.display = "";
    errorElement.textContent = "Current Password is incorrect";
    wrapperElement.classList.toggle("has-error", true);
}
function $31691340282c7066$var$login() {
    document.getElementById("loading").style.display = "flex";
    $31691340282c7066$var$setAllLogoDisplays("none");
    document.getElementById("loginErr").style.display = "none";
    return (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes().then((routes)=>{
        //post to N.cali auth server to find out which region
        let config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        (0, $7ab954312ef88736$export$2e2bcd8739ae039).post((()=>{
            const params = new URLSearchParams(window.location.search);
            const redirectUrlParam = params.get("redirect_uri");
            const base = routes.backendAuthServer + "/login";
            return redirectUrlParam ? `${base}?redirect_uri=${encodeURIComponent(redirectUrlParam)}` : base;
        })(), {
            username: document.getElementById("username").value,
            password: document.getElementById("password").value,
            isMobile: $31691340282c7066$var$checkMobile()
        }, config).then(function(response) {
            if (response.data.success) {
                // console.log(response.data);
                $31691340282c7066$var$setCookie("languageCookie", $31691340282c7066$var$getCookie("languageCookie"), 365);
                //save pass info here.
                const box3 = document.getElementById("box3");
                if (box3 && box3.checked) $31691340282c7066$var$setLoginLocalStorage(document.getElementById("username").value, document.getElementById("password").value);
                else $31691340282c7066$var$clearLoginLocalStorage($31691340282c7066$var$userField, $31691340282c7066$var$passField);
                $31691340282c7066$var$deleteUnusedCookies(response.data.link);
                /*
                  The server is going to have to return the URL they should be directed to..... Only it can know what creds each user has...
               */ //if there is a document.referrer then they came here un-authenticated from an app subdomain so save that and once logged in shoot them over to where they were trying to go
                //catch if there is a document referrer. This is for white label customers. If they are a white label customer their subdomain will point to the app server, if they are not logged in they will be forwarded to auth.limblecmms.com where the logo will get replaced based on document referrer, and this will send them to their sub-domain app server
                // if (
                //    document.referrer.includes(".limblecmms.com") &&
                //    !document.referrer.includes("https://limblecmms.com") &&
                //    !document.referrer.includes("https://www.limblecmms.com")
                // ) {
                //This needs to be a bit smarter for white label customers and direct them to the page they have access to, but also the white label domain. Find a way to do this without string replacing... hopefully.
                //    window.location.href = document.referrer;
                // } else {
                if ($31691340282c7066$var$isESignatureVerification) {
                    window.sessionStorage.removeItem("loginAttemptNumber");
                    window.parent.postMessage({
                        success: true,
                        user: response.data.user
                    }, routes.appUrl);
                } else if ($31691340282c7066$var$isOAuth) ;
                else {
                    const redirectUrl = $31691340282c7066$var$evaluateRedirectUri(response.data.link);
                    $31691340282c7066$var$navigateToApp(redirectUrl);
                }
                // }
                //if remember me was checked then store their username and password in a cookie
                $31691340282c7066$var$eventBus.publish("login", response.data);
            } else if (response.data.success == false && response.data.pwExpired == true) {
                if ($31691340282c7066$var$USE_NEW_PW_EXPIRED) {
                    $31691340282c7066$var$togglePwExpiredVisibility();
                    $31691340282c7066$var$addEventListenersToPasswords();
                } else {
                    document.getElementById("loading").style.display = "none";
                    //display forgot my password modal with a message telling the user their password expired and will have to reset it via email
                    openModal();
                    document.getElementById("pwExpired").style.display = "";
                }
            } else {
                //display message saying login failed
                $31691340282c7066$var$setAllLogoDisplays("none");
                if (!$31691340282c7066$var$isESignatureVerification) document.getElementById("errorContainer").classList.add("p-b-32");
                document.getElementById("loginErr").style.display = "";
            }
        // console.log(response, "response from auth server");
        }).catch(function(error) {
            $31691340282c7066$var$setAllLogoDisplays();
            if (!$31691340282c7066$var$isESignatureVerification) document.getElementById("errorContainer").classList.add("p-b-32");
            document.getElementById("loginErr").style.display = "";
            document.getElementById("loading").style.display = "none";
            if (document.getElementById("ssoProviderErr")) document.getElementById("ssoProviderErr").style.display = "block";
            // console.log("CATCH ERROR");
            console.log(error);
            if ($31691340282c7066$var$isESignatureVerification) {
                let loginAttemptNumber = window.sessionStorage.getItem("loginAttemptNumber") ?? 0;
                if (loginAttemptNumber >= 3) {
                    window.sessionStorage.removeItem("loginAttemptNumber");
                    window.parent.postMessage({
                        success: false,
                        user: 0
                    }, routes.appUrl);
                    return;
                }
                window.sessionStorage.setItem("loginAttemptNumber", ++loginAttemptNumber);
                $31691340282c7066$var$setElementAttribute("loginAttemptNumber", "innerHTML", loginAttemptNumber);
            }
        });
    //get the region return and post to that region's auth server
    });
}
//forgot my password button clicked here.
function $31691340282c7066$var$enableForgotPassword() {
    document.getElementById("forgotPwBtn").disabled = false;
}
window.enableForgotPassword = $31691340282c7066$var$enableForgotPassword;
function $31691340282c7066$var$forgotMyPassword() {
    document.getElementById("forgotPasswordSuccess").style.display = "none";
    if (document.getElementById("forgotMyPasswordUsername").value) return (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes().then((routes)=>{
        $31691340282c7066$var$setAllLogoDisplays("none");
        //post to N.cali auth server to find out which region
        var config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        $31691340282c7066$var$isStaging = routes.backendAuthServer && routes.backendAuthServer.includes("staging");
        const requestData = {
            username: document.getElementById("forgotMyPasswordUsername").value,
            hcaptcha_client_response: $31691340282c7066$var$isStaging ? "staging-bypass" : hcaptcha.getResponse()
        };
        (0, $7ab954312ef88736$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/forgotMyPassword", requestData, config).then(function(response) {
            $31691340282c7066$var$setAllLogoDisplays();
            document.getElementById("forgotPasswordErrorHandlingStyles").classList.add("p-b-32");
            if (response.data.success) document.getElementById("forgotPasswordSuccess").style.display = "inline";
            else {
                document.getElementById("forgotPasswordSuccess").style.display = "inline";
                document.getElementById("loginErr").style.display = "none";
            }
            // console.log(response, "response from auth server");
            if ($31691340282c7066$var$isESignatureVerification) window.parent.postMessage({
                success: null,
                user: 0
            }, routes.appUrl);
        }).catch(function(error) {
            document.getElementById("forgotPasswordErrorHandlingStyles").classList.add("p-b-32");
            document.getElementById("loginErr").style.display = "";
            console.log(error);
        });
    //get the region return and post to that region's auth server
    });
    else return;
}
let $31691340282c7066$var$customerPasswordLength = 8;
let $31691340282c7066$var$currentPasswordFieldErrors = [];
let $31691340282c7066$var$newPasswordFieldErrors = [];
let $31691340282c7066$var$repeatPasswordFieldErrors = [];
function $31691340282c7066$var$validateCurrentPassword(currentPassword) {
    $31691340282c7066$var$currentPasswordFieldErrors = [];
    if (!currentPassword) {
        $31691340282c7066$var$currentPasswordFieldErrors.push(document.lang.CurrentPasswordIsBlank ?? "Enter your current password");
        return false;
    }
    return true;
}
function $31691340282c7066$var$validateNewPassword(newPassword, currentPassword) {
    $31691340282c7066$var$newPasswordFieldErrors = [];
    if (!newPassword) {
        $31691340282c7066$var$newPasswordFieldErrors.push(document.lang.NewPasswordIsBlank ?? "Enter your new password");
        return false;
    }
    if (newPassword.length < $31691340282c7066$var$customerPasswordLength) {
        var errorMessage;
        if (typeof document?.lang?.yourPasswordMustBeAtLeast == "undefined") errorMessage = "Your password must be at least this many characters: " + ` ${$31691340282c7066$var$customerPasswordLength}`;
        else errorMessage = document.lang.yourPasswordMustBeAtLeast + `: ${$31691340282c7066$var$customerPasswordLength}`;
        $31691340282c7066$var$newPasswordFieldErrors.push(errorMessage);
    }
    if (!/^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<~`>/?]*$/.test(newPassword)) $31691340282c7066$var$newPasswordFieldErrors.push(document.lang.PasswordOnlyLettersNumbersCharacters ?? "Your password can only contain letters, numbers, and special characters.");
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<~`>/?])/.test(newPassword)) $31691340282c7066$var$newPasswordFieldErrors.push(document.lang.PasswordMustContainUpperLowerNumberSymbol ?? "Your password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.");
    if (currentPassword && currentPassword === newPassword) $31691340282c7066$var$newPasswordFieldErrors.push(document.lang.YourNewPasswordCannotMatchYourOldPassword ?? "Your new password cannot match your old password");
    return $31691340282c7066$var$newPasswordFieldErrors.length === 0;
}
function $31691340282c7066$var$validateRepeatPassword(repeatPassword, newPassword) {
    $31691340282c7066$var$repeatPasswordFieldErrors = [];
    if (!repeatPassword) {
        $31691340282c7066$var$repeatPasswordFieldErrors.push(document.lang.ConfirmNewPasswordIsBlank ?? "Enter your new password again");
        return false;
    }
    if (newPassword && newPassword !== repeatPassword) {
        $31691340282c7066$var$repeatPasswordFieldErrors.push(document.lang.NewPasswordsDontMatchReenter ?? "New passwords do not match. Update and try again.");
        return false;
    }
    return true;
}
async function $31691340282c7066$var$getCustomerPasswordRequirements() {
    if (document.getElementById("username").value) return (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes().then((routes)=>{
        //post to N.cali auth server to find out which region
        var config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        (0, $7ab954312ef88736$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/passwordMinLength", {
            username: document.getElementById("username").value
        }, config).then(function(response) {
            if (response.data.success) $31691340282c7066$var$customerPasswordLength = response.data.pwMinLength;
            else $31691340282c7066$var$customerPasswordLength = 8;
            $31691340282c7066$var$updatePasswordExpiredLengthWarning($31691340282c7066$var$customerPasswordLength);
        }).catch(function() {
            $31691340282c7066$var$customerPasswordLength = 8;
            $31691340282c7066$var$updatePasswordExpiredLengthWarning($31691340282c7066$var$customerPasswordLength);
        });
    });
    else return;
}
function $31691340282c7066$var$updatePasswordExpiredLengthWarning(minLength) {
    const lengthWarningSpan = document.getElementById("pwExpiredLengthWarning");
    var errorMessage;
    if (typeof document?.lang?.yourPasswordMustBeAtLeast == "undefined") errorMessage = "Your password must be at least this many characters: " + ` ${minLength}`;
    else errorMessage = document.lang.yourPasswordMustBeAtLeast + `: ${minLength}`;
    $31691340282c7066$var$newPasswordFieldErrors.push(errorMessage);
    if (lengthWarningSpan) lengthWarningSpan.textContent = errorMessage;
}
function $31691340282c7066$var$togglePwExpiredVisibility() {
    document.getElementById("loading").style.display = "none";
    document.getElementById("loginForm").style.display = "none";
    document.getElementById("newPwExpired").style.display = "";
    document.getElementById("signUpDiv").style.display = "none";
    document.getElementById("legalTermsSection").style.display = "none";
    $31691340282c7066$var$getCustomerPasswordRequirements();
    $31691340282c7066$var$setAllLogoDisplays("");
}
function $31691340282c7066$var$setupPasswordVisibilityToggle(toggleId, passwordId) {
    const toggleButton = document.querySelector(`#${toggleId}`);
    const passwordField = document.querySelector(`#${passwordId}`);
    toggleButton?.addEventListener("click", function() {
        const type = passwordField.getAttribute("type") === "password" ? "text" : "password";
        passwordField.setAttribute("type", type);
        this.classList.toggle("fa-eye-slash");
        this.classList.toggle("fa-eye");
    });
}
function $31691340282c7066$var$addEventListenersToPasswords() {
    const currentPasswordField = document.getElementById("currentPassword");
    const newPasswordField = document.getElementById("newPassword");
    const confirmNewPass = document.getElementById("confirmNewPass");
    const updatePasswordBtn = document.getElementById("updatePasswordBtn");
    if (currentPasswordField && newPasswordField && confirmNewPass) {
        currentPasswordField.addEventListener("blur", function() {
            const isValid = $31691340282c7066$var$validateCurrentPassword(this.value);
            const errorElement = document.getElementById("currentPasswordFieldError");
            const wrapperElement = this.closest(".wrap-input");
            errorElement.textContent = $31691340282c7066$var$currentPasswordFieldErrors.join(",\n");
            errorElement.style.display = isValid ? "none" : "";
            wrapperElement.classList.toggle("has-error", !isValid);
        });
        newPasswordField.addEventListener("blur", function() {
            const isValid = $31691340282c7066$var$validateNewPassword(this.value, currentPasswordField.value);
            const errorElement = document.getElementById("newPasswordFieldError");
            const wrapperElement = this.closest(".wrap-input");
            errorElement.textContent = $31691340282c7066$var$newPasswordFieldErrors.join(",\n");
            errorElement.style.display = isValid ? "none" : "";
            wrapperElement.classList.toggle("has-error", !isValid);
        });
        confirmNewPass.addEventListener("blur", function() {
            const isValid = $31691340282c7066$var$validateRepeatPassword(this.value, newPasswordField.value);
            const errorElement = document.getElementById("confirmNewPassFieldError");
            const wrapperElement = this.closest(".wrap-input");
            errorElement.textContent = $31691340282c7066$var$repeatPasswordFieldErrors.join(",\n");
            errorElement.style.display = isValid ? "none" : "";
            wrapperElement.classList.toggle("has-error", !isValid);
        });
        // Set up toggle functionality for all password fields
        $31691340282c7066$var$setupPasswordVisibilityToggle("toggleCurrentPassword", "currentPassword");
        $31691340282c7066$var$setupPasswordVisibilityToggle("toggleNewPassword", "newPassword");
        $31691340282c7066$var$setupPasswordVisibilityToggle("toggleConfirmNewPass", "confirmNewPass");
        // turn on the update password button
        updatePasswordBtn.addEventListener("click", function(e) {
            e.preventDefault();
            const isCurrentPasswordValid = $31691340282c7066$var$validateCurrentPassword(currentPasswordField.value);
            const isNewPasswordValid = $31691340282c7066$var$validateNewPassword(newPasswordField.value, currentPasswordField.value);
            const isConfirmPasswordValid = $31691340282c7066$var$validateRepeatPassword(confirmNewPass.value, newPasswordField.value);
            if (isCurrentPasswordValid && isNewPasswordValid && isConfirmPasswordValid) // All validations passed, proceed with password update
            $31691340282c7066$var$submitPasswordUpdate(currentPasswordField.value, newPasswordField.value);
        });
    }
}
let $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($03a008e57426b866$exports)));
function $31691340282c7066$var$checkWhiteLabelDomainMatch(domain) {
    if (document.referrer.includes(domain)) return true;
    else if ($31691340282c7066$var$getCookie("whiteLabelSubDomain").includes(domain)) return true;
    else return false;
}
if ($31691340282c7066$var$checkWhiteLabelDomainMatch("dhl.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($d644a2e113e7a9b3$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("neutron.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($27f17e0e06e41d97$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("enco.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($c51f741d7c4b72c5$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("deliver-ez.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($b47f6b0f371800d3$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("epic.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($59a05e5548888bd6$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("iotplus.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($22ecd0c291f7f48e$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("invata.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($c6637c58df03779e$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("netswat.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($6cc3a35ebc8d678b$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("demirer.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($462e7f44f8eafbb4$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("scandinaviandrone.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($bc0db72104fba2a4$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("comstockfs.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($29ed0de9178d3fc0$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("harrigan.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($a99cada972d0f1e6$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("sentegrity.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($a4b9bdbb68cd673e$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("dartbrook.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($70cedad54c00ad49$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("redaptive.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($1d2002b68fdcabf7$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("johndeere.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($f5b3c73a633d2bb4$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("kettering.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($868461de1da1a260$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("homefix.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($c4604ffb66eabc1e$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("intelsat.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($1301127d4e43a2c5$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("jbmpackaging.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($070000135cf2724e$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("access.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($239e337f52cd8b4d$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("canyonridgeservices.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($16346f3b9680e038$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("watermarkcommunitychurch.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($f23d1a9e60427824$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("oregonfoodbank.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($343fd1c9e7bd515a$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("gbc.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($c3f84942cd8b75e6$exports)));
else if ($31691340282c7066$var$checkWhiteLabelDomainMatch("tqlfacilities.limblecmms.com")) $31691340282c7066$var$src = (0, (/*@__PURE__*/$parcel$interopDefault($d986c59897a4c052$exports)));
var $31691340282c7066$var$logos = document.getElementsByClassName("logo");
for(var $31691340282c7066$var$i = 0; $31691340282c7066$var$i < $31691340282c7066$var$logos.length; ++$31691340282c7066$var$i){
    var $31691340282c7066$var$item = $31691340282c7066$var$logos[$31691340282c7066$var$i];
    $31691340282c7066$var$item.src = $31691340282c7066$var$src;
}
/*

END OF WHITE LABEL CUSTOMER SECTION

*/ //if remember me is checked then store creds inside of local storage? or maybe not just use secure cookie?
//read the customer's lang cookie and set the front end to foriegn language
/*
   Language Setting
*/ //default setting is english
//Talk to nathan about this maybe? Lang files are pretty big maybe it's better to not load them all on page load
//if not lang cookie then default to english first
// setCookie("languageCookie", "english", 365);
//else read lang cookie and select that language first.
// console.log(getCookie('languageCookie'));
if (!$31691340282c7066$var$getCookie("languageCookie")) {
    $31691340282c7066$var$setCookie("languageCookie", "english", 365);
    $31691340282c7066$var$loadLang("english");
} else {
    let lang = $31691340282c7066$var$getCookie("languageCookie");
    $31691340282c7066$var$loadLang(lang);
}
const $31691340282c7066$var$queryString = window.location.search;
const $31691340282c7066$var$urlParams = new URLSearchParams($31691340282c7066$var$queryString);
const $31691340282c7066$var$error = $31691340282c7066$var$urlParams.get("error");
const $31691340282c7066$var$idp = $31691340282c7066$var$urlParams.get("idp");
if ($31691340282c7066$var$idp == "true" && $31691340282c7066$var$getCookie("ssoUsername")) $31691340282c7066$var$determineSSOProvider($31691340282c7066$var$getCookie("ssoUsername")).then(function(answer) {
    window.location.href = answer.data.ssoUrl;
});
document.getElementById("ssoProviderErr").innerHTML = $31691340282c7066$var$error;
function $31691340282c7066$var$setFrontEnd() {
    // Due to time constraints, some phrases in esignature verification will not be translated
    if (!$31691340282c7066$var$isESignatureVerification) {
        $31691340282c7066$var$setElementAttribute("loginErr", "innerHTML", document.lang.LoginErrorCheckUsernamePassword);
        $31691340282c7066$var$setElementAttribute("loginBtn", "innerHTML", document.lang.login);
    }
    const loginAttemptNumber = window.sessionStorage.getItem("loginAttemptNumber");
    if ($31691340282c7066$var$isESignatureVerification && loginAttemptNumber > 0) {
        document.getElementById("loginErr").style.display = "";
        $31691340282c7066$var$setElementAttribute("loginAttemptNumber", "innerHTML", loginAttemptNumber);
    }
    const languageCookieString = $31691340282c7066$var$getCookie("languageCookie");
    if (languageCookieString === "english") $31691340282c7066$var$setElementAttribute("slogan", "innerHTML", "<span id='empowerTextSwoosh'>Empower<img id='empowerImage' /></span> the unsung heroes that support the world");
    else $31691340282c7066$var$setElementAttribute("slogan", "innerHTML", document.lang.EmpowerSlogan);
    $31691340282c7066$var$setInternationalization();
    document.getElementById("sso").addEventListener("click", $31691340282c7066$var$enterSSOUsernameManually);
    document.getElementById("forgotMyPasswordBtn").addEventListener("click", $31691340282c7066$var$forgotPasswordClicked);
    document.getElementById("forgot-back-button").addEventListener("click", $31691340282c7066$var$backButtonClicked);
    document.getElementById("sso-back-button").addEventListener("click", $31691340282c7066$var$backButtonClicked);
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop)=>searchParams.get(prop)
    });
    if (params.autofill === "true") {
        $31691340282c7066$var$setElementAttribute("username", "value", params.username);
        $31691340282c7066$var$setElementAttribute("ssoUsername", "value", params.userEmail);
    }
}
function $31691340282c7066$var$setInternationalization() {
    $31691340282c7066$var$setElementAttribute("empowerImage", "src", (0, (/*@__PURE__*/$parcel$interopDefault($97f2ebd491ea1c56$exports))));
    $31691340282c7066$var$setElementAttribute("forgotMyPasswordBtn", "innerHTML", document.lang.forgotPassword);
    $31691340282c7066$var$setElementAttribute("rememberMe", "innerHTML", document.lang.rememberMe);
    $31691340282c7066$var$setElementAttribute("dontHaveAnAccount", "innerHTML", document.lang.DoesYourCompanyNotHaveAnAccount);
    $31691340282c7066$var$setElementAttribute("email-login-label-text", "innerHTML", document.lang.username);
    $31691340282c7066$var$setElementAttribute("emailTooltip", "title", document.lang.UsernameLoginTooltip);
    $31691340282c7066$var$setElementAttribute("password-login-label", "innerHTML", document.lang.password);
    $31691340282c7066$var$setElementAttribute("forgotMyPasswordUsernameLabel", "innerHTML", document.lang.username);
    $31691340282c7066$var$setElementAttribute("forgotPwBtn", "innerHTML", document.lang.ResetPassword);
    $31691340282c7066$var$setElementAttribute("forgotPasswordInstruction", "innerHTML", document.lang.ForgotPasswordResetInstructions);
    $31691340282c7066$var$setElementAttribute("forgot-back-button", "innerHTML", document.lang.BackToMainPage);
    $31691340282c7066$var$setElementAttribute("signUpLink", "innerHTML", " " + document.lang.SignUp + " ");
    $31691340282c7066$var$setElementAttribute("sso-back-button", "innerHTML", document.lang.BackToMainPage);
    const termsOfServiceLink = '<a href="https://limblecmms.com/terms-of-service/"target="_blank">' + document.lang.TermsOfService + "</a> ";
    const privacyPolicyLink = ' <a href="https://limblecmms.com/privacy/" target="_blank">' + document.lang.PrivacyPolicy + "</a>";
    $31691340282c7066$var$setElementAttribute("legalTermsSection", "innerHTML", 'By clicking "Login" you agree to Limble\'s <br />' + termsOfServiceLink + document.lang.and + privacyPolicyLink);
    $31691340282c7066$var$setElementAttribute("pwExpiredOrgPolicy", "innerHTML", document.lang.UpdatePasswordEvery90Days);
    $31691340282c7066$var$setElementAttribute("pwExpiredLengthWarningText", "innerHTML", document.lang.yourPasswordMustBeAtLeast + `: 8`);
    $31691340282c7066$var$setElementAttribute("updatePasswordBtn", "innerHTML", document.lang.UpdatePassword);
    $31691340282c7066$var$setElementAttribute("current-password-label", "innerHTML", document.lang.CurrentPassword);
    $31691340282c7066$var$setElementAttribute("new-password-label", "innerHTML", document.lang.NewPassword);
    $31691340282c7066$var$setElementAttribute("repeat-password-label", "innerHTML", document.lang.ConfirmNewPassword);
}
function $31691340282c7066$var$setElementAttribute(elementId, attribute, value) {
    const element = document.getElementById(elementId);
    if (element) element[attribute] = value;
}
function $31691340282c7066$var$determineSSOProvider(username) {
    let oauthInteraction = "";
    if ($31691340282c7066$var$isOAuth) oauthInteraction = window.location.pathname.split("/").pop();
    // Forward the webApp returnUrl (set as a query param on this page) so
    // /ssoLogin can redirect the user back to where they started after an
    // e-signature SSO round-trip.
    const params = new URLSearchParams(window.location.search);
    const returnUrl = params.get("returnUrl") || "";
    return (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes().then((routes)=>{
        var config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        return (0, $7ab954312ef88736$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/checkProvider", {
            username: username,
            isMobile: $31691340282c7066$var$checkMobile(),
            oauthInteraction: oauthInteraction,
            returnUrl: returnUrl
        }, config).then(function(answer) {
            return answer;
        });
    });
}
function $31691340282c7066$var$verifyESignatureVerificationToken() {
    return (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes().then((routes)=>{
        var config = {
            headers: {
                "Access-Control-Allow-Origin": routes.backendAuthServer
            },
            withCredentials: true
        };
        return (0, $7ab954312ef88736$export$2e2bcd8739ae039).post(routes.backendAuthServer + "/verifyESignatureVerificationToken", {}, config).then(function(answer) {
            return answer;
        });
    });
}
function $31691340282c7066$var$forgotPasswordClicked() {
    document.getElementById("loginForm").style.display = "none";
    document.getElementById("manualForgotPassword").style.display = "block";
    if ($31691340282c7066$var$isESignatureVerification) {
        document.getElementById("login-btn-container").style.display = "none";
        document.getElementById("forgot-password-btn-container").style.display = "flex";
        document.getElementById("forgot-password-warning").style.display = "block";
        $31691340282c7066$var$setElementAttribute("main-title", "innerHTML", "Forgot Password?");
        $31691340282c7066$var$setElementAttribute("subtitle", "innerHTML", "Please enter your username to receive an email to reset your password.");
    }
}
function $31691340282c7066$var$backButtonClicked() {
    document.getElementById("loginForm").style.display = "";
    document.getElementById("manualSSOUsername").style.display = "none";
    document.getElementById("manualForgotPassword").style.display = "none";
    document.getElementById("newPwExpired").style.display = "none";
    document.getElementById("updatePasswordMessage").style.display = "none";
    if ($31691340282c7066$var$isESignatureVerification) {
        document.getElementById("login-btn-container").style.display = "flex";
        document.getElementById("sso-btn-container").style.display = "none";
        document.getElementById("forgot-password-btn-container").style.display = "none";
        document.getElementById("forgot-password-warning").style.display = "none";
        $31691340282c7066$var$setElementAttribute("main-title", "innerHTML", "Please verify your identity");
        $31691340282c7066$var$setElementAttribute("subtitle", "innerHTML", "I verify that I am the author of this signature.");
    }
}
function $31691340282c7066$var$enterSSOUsernameManually() {
    document.getElementById("loginForm").style.display = "none";
    document.getElementById("manualSSOUsername").style.display = "block";
    if ($31691340282c7066$var$getCookie("ssoUsername")) $31691340282c7066$var$setElementAttribute("ssoUsername", "value", $31691340282c7066$var$getCookie("ssoUsername"));
    document.getElementById("ssoUsernameSubmit").addEventListener("click", function() {
        $31691340282c7066$var$submitSSOUsername();
    });
    if ($31691340282c7066$var$isESignatureVerification) {
        document.getElementById("login-btn-container").style.display = "none";
        document.getElementById("sso-btn-container").style.display = "flex";
        $31691340282c7066$var$setElementAttribute("main-title", "innerHTML", "Verify with SSO");
    }
}
function $31691340282c7066$var$submitSSOUsername() {
    const username = document.getElementById("ssoUsername").value;
    $31691340282c7066$var$determineSSOProvider(username).then(function(answer) {
        const { ssoUrl: ssoUrl, success: success, eSignatureUseNewFlow: eSignatureUseNewFlow } = answer.data;
        if (success) {
            if ($31691340282c7066$var$isESignatureVerification) {
                $31691340282c7066$var$handleESignatureSSOLogin(ssoUrl, !!eSignatureUseNewFlow);
                return;
            }
            window.location.href = ssoUrl;
        }
    }).catch(function(e) {
        document.getElementById("ssoLoginErr").style.display = "block";
    });
}
function $31691340282c7066$var$handleESignatureSSOLogin(ssoUrl, useNewFlow) {
    if (useNewFlow) // New flow (gated by `esig-update-202605`): ask the parent webApp to
    // navigate the top window to the IdP. iOS Safari blocks window.open()
    // from cross-origin iframes and ITP prevents the iframe from reading the
    // auth-server cookie set by a popup, so we can't poll for it.
    return (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes().then((routes)=>{
        window.parent.postMessage({
            type: "esign-sso-redirect",
            url: ssoUrl
        }, routes.appUrl);
    });
    // Legacy flow: pop a window to the IdP and poll for the cookie that the
    // /ssoLogin callback drops on the auth-server domain. Works on Chrome/desktop
    // browsers without ITP restrictions.
    const popup = window.open(ssoUrl, "ssoLogin", "popup=true, width=200, height=200");
    if (!popup) {
        window.alert("Please disable your popup blocker and try again.");
        return;
    }
    return (0, $eb8625b45480c82f$export$2e2bcd8739ae039).getRoutes().then((routes)=>{
        const interval = setInterval(()=>{
            const eSignatureVerificationToken = $31691340282c7066$var$getCookie("eSignatureVerificationToken");
            if (eSignatureVerificationToken) {
                clearInterval(interval);
                popup.close();
                $31691340282c7066$var$verifyESignatureVerificationToken().then((answer)=>{
                    $31691340282c7066$var$delete_cookie("eSignatureVerificationToken", "/");
                    window.sessionStorage.removeItem("loginAttemptNumber");
                    window.parent.postMessage({
                        success: answer.data.success,
                        user: answer.data.userID
                    }, routes.appUrl);
                });
            }
        }, 1000);
    });
}
document.getElementById("manualSSOUsername").addEventListener("keydown", function(event) {
    if (event.key == "Enter") $31691340282c7066$var$submitSSOUsername();
}, false);
function $31691340282c7066$var$setCookie(cname, value) {
    var d = new Date();
    d.setTime(d.getTime() + 2592000000);
    var expires = "expires=" + d.toUTCString();
    if (window.location.hostname.includes("localhost")) {
        $31691340282c7066$var$delete_cookie(cname, "/", "");
        document.cookie = cname + "=" + value + ";" + expires + ";";
    } else {
        $31691340282c7066$var$delete_cookie(cname, "/", "limblecmms.com");
        document.cookie = cname + "=" + value + ";" + expires + ";Domain=limblecmms.com";
    }
}
function $31691340282c7066$var$delete_cookie(name, path, domain) {
    if ($31691340282c7066$var$getCookie(name)) document.cookie = name + "=" + (path ? ";path=" + path : "") + (domain ? ";domain=" + domain : "") + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
}
function $31691340282c7066$var$getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
function $31691340282c7066$var$getCookies(prefixes) {
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    var found = [];
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        for(var j = 0; j < prefixes.length; j++)if (c.indexOf(prefixes[j]) == 0) {
            var r = c.split("=", 2);
            found[r[0]] = r[1];
            break;
        }
    }
    return found;
}
/**
 * Deletes old cookies that are no longer used.
 */ function $31691340282c7066$var$deleteUnusedCookies(redirect) {
    var prefixes = [
        "ph_phc"
    ];
    // temporary until we completely move CDN providers
    if (!/^https:\/\/(?:21cfr-)?app\.limblecmms\.com/.test(redirect)) // clear imperva cookies unless we redirecting to us-prod or 21cfr
    prefixes.push("incap", "visid_incap");
    const cookies = $31691340282c7066$var$getCookies(prefixes);
    const domains = $31691340282c7066$var$calculateCookieDomains();
    for(var domain in domains)for(var key in cookies)$31691340282c7066$var$delete_cookie(key, "/", domain);
}
/**
 * Calculates all possible cookie domains for the current hostname.
 * @returns {Object} An object with all possible cookie domains as keys.
 */ function $31691340282c7066$var$calculateCookieDomains() {
    var carry = document.location.hostname;
    var domains = {};
    domains[""] = true;
    while(carry.indexOf(".") != carry.lastIndexOf(".")){
        carry = carry.split(".").slice(1).join(".");
        domains[carry] = true;
    }
    return domains;
}
































function $31691340282c7066$var$loadLang(lang) {
    if (lang == "english") {
        const en = (parcelRequire("f16Zt"));
        en.then(function(en) {
            document.lang = en;
            $31691340282c7066$var$setFrontEnd();
            $31691340282c7066$var$setCookie("languageCookie", "english");
        });
    } else if (lang == "estonian") {
        const et = (parcelRequire("6bf00"));
        et.then(function(et) {
            document.lang = et;
            $31691340282c7066$var$setCookie("languageCookie", "estonian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "slovenian") {
        const sl = (parcelRequire("1qoYS"));
        sl.then(function(sl) {
            document.lang = sl;
            $31691340282c7066$var$setCookie("languageCookie", "slovenian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "spanish") {
        const es = (parcelRequire("aNq9N"));
        es.then(function(es) {
            document.lang = es;
            $31691340282c7066$var$setCookie("languageCookie", "spanish");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "thai") {
        const th = (parcelRequire("e1U8g"));
        th.then(function(th) {
            document.lang = th;
            $31691340282c7066$var$setCookie("languageCookie", "thai");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "french") {
        const fr = (parcelRequire("b0ekd"));
        fr.then(function(fr) {
            document.lang = fr;
            $31691340282c7066$var$setCookie("languageCookie", "french");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "portuguese") {
        const pt = (parcelRequire("e2WhP"));
        pt.then(function(pt) {
            document.lang = pt;
            $31691340282c7066$var$setCookie("languageCookie", "portuguese");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "hebrew") {
        const he = (parcelRequire("hB9az"));
        he.then(function(he) {
            document.lang = he;
            $31691340282c7066$var$setCookie("languageCookie", "hebrew");
            $31691340282c7066$var$setFrontEnd();
            document.body.classList.add("rightBodyAlignText");
        });
    } else if (lang == "german") {
        const de = (parcelRequire("k2XGL"));
        de.then(function(de) {
            document.lang = de;
            $31691340282c7066$var$setCookie("languageCookie", "german");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "chinese") {
        const zh = (parcelRequire("lLNQz"));
        zh.then(function(zh) {
            document.lang = zh;
            $31691340282c7066$var$setCookie("languageCookie", "chinese");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "arabic") {
        const ar = (parcelRequire("g1GOh"));
        ar.then(function(ar) {
            document.lang = ar;
            $31691340282c7066$var$setCookie("languageCookie", "arabic");
            $31691340282c7066$var$setFrontEnd();
            document.body.classList.add("rightBodyAlignText");
        });
    } else if (lang == "bulgarian") {
        const bg = (parcelRequire("4AQwh"));
        bg.then(function(bg) {
            document.lang = bg;
            $31691340282c7066$var$setCookie("languageCookie", "bulgarian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "czech") {
        const cs = (parcelRequire("grRrM"));
        cs.then(function(cs) {
            document.lang = cs;
            $31691340282c7066$var$setCookie("languageCookie", "czech");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "farsi") {
        const fa = (parcelRequire("9DvqF"));
        fa.then(function(fa) {
            document.lang = fa;
            $31691340282c7066$var$setCookie("languageCookie", "farsi");
            $31691340282c7066$var$setFrontEnd();
            document.body.classList.add("rightBodyAlignText");
        });
    } else if (lang == "hungarian") {
        const hu = (parcelRequire("ias7f"));
        hu.then(function(hu) {
            document.lang = hu;
            $31691340282c7066$var$setCookie("languageCookie", "hungarian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "italian") {
        const it = (parcelRequire("9u9zO"));
        it.then(function(it) {
            document.lang = it;
            $31691340282c7066$var$setCookie("languageCookie", "italian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "japanese") {
        const ja = (parcelRequire("iDWwE"));
        ja.then(function(ja) {
            document.lang = ja;
            $31691340282c7066$var$setCookie("languageCookie", "japanese");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "korean") {
        const ko = (parcelRequire("6vW2c"));
        ko.then(function(ko) {
            document.lang = ko;
            $31691340282c7066$var$setCookie("languageCookie", "korean");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "latvian") {
        const lv = (parcelRequire("6K5u9"));
        lv.then(function(lv) {
            document.lang = lv;
            $31691340282c7066$var$setCookie("languageCookie", "latvian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "dutch") {
        const nl = (parcelRequire("f2AKi"));
        nl.then(function(nl) {
            document.lang = nl;
            $31691340282c7066$var$setCookie("languageCookie", "dutch");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "norwegian") {
        const no = (parcelRequire("6xa38"));
        no.then(function(no) {
            document.lang = no;
            $31691340282c7066$var$setCookie("languageCookie", "norwegian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "indonesian") {
        const no = (parcelRequire("kscXV"));
        no.then(function(no) {
            document.lang = no;
            $31691340282c7066$var$setCookie("languageCookie", "indonesian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "polish") {
        const pl = (parcelRequire("i2m7h"));
        pl.then(function(pl) {
            document.lang = pl;
            $31691340282c7066$var$setCookie("languageCookie", "polish");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "romanian") {
        const ro = (parcelRequire("4Jy9F"));
        ro.then(function(ro) {
            document.lang = ro;
            $31691340282c7066$var$setCookie("languageCookie", "romanian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "russian") {
        const ru = (parcelRequire("4nnBo"));
        ru.then(function(ru) {
            document.lang = ru;
            $31691340282c7066$var$setCookie("languageCookie", "russian");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "swedish") {
        const sv = (parcelRequire("2v6yB"));
        sv.then(function(sv) {
            document.lang = sv;
            $31691340282c7066$var$setCookie("languageCookie", "swedish");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "swahili") {
        const sw = (parcelRequire("1GbfB"));
        sw.then(function(sw) {
            document.lang = sw;
            $31691340282c7066$var$setCookie("languageCookie", "swahili");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "tagalog") {
        const tl = (parcelRequire("knBc5"));
        tl.then(function(tl) {
            document.lang = tl;
            $31691340282c7066$var$setCookie("languageCookie", "tagalog");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "tajik") {
        const tg = (parcelRequire("aibCe"));
        tg.then(function(tg) {
            document.lang = tg;
            $31691340282c7066$var$setCookie("languageCookie", "tajik");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "turkish") {
        const tr = (parcelRequire("ihKaL"));
        tr.then(function(tr) {
            document.lang = tr;
            $31691340282c7066$var$setCookie("languageCookie", "turkish");
            $31691340282c7066$var$setFrontEnd();
        });
    } else if (lang == "vietnamese") {
        const vi = (parcelRequire("d1tPy"));
        vi.then(function(vi) {
            document.lang = vi;
            $31691340282c7066$var$setCookie("languageCookie", "vietnamese");
            $31691340282c7066$var$setFrontEnd();
        });
    } else {
        const en = (parcelRequire("f16Zt"));
        en.then(function(en) {
            document.lang = en;
            $31691340282c7066$var$setFrontEnd();
            $31691340282c7066$var$setCookie("languageCookie", "english");
        });
    }
}
// function setLang() {
// 	var selectBox = document.getElementById('lang');
// 	var selectedValue = selectBox.options[selectBox.selectedIndex].value;
// 	if (selectedValue == 'english') {
// 		loadLang('english');
// 	} else if (selectedValue == 'spanish') {
// 		loadLang('spanish');
// 	} else if (selectedValue == 'thai') {
// 		loadLang('thai');
// 	} else if (selectedValue == 'french') {
// 		loadLang('french');
// 	} else if (selectedValue == 'portuguese') {
// 		loadLang('portuguese');
// 	} else if (selectedValue == 'hebrew') {
// 		loadLang('hebrew');
// 	}
// }
// document.setLang = setLang;
/*
General Use functions
*/ function $31691340282c7066$var$checkMobile() {
    if (navigator.userAgent.includes("gonative")) return true;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) return true;
    let mobile = new RegExp("m=true").test(window.location.href);
    if (mobile) return true;
    return false;
}
function $31691340282c7066$var$isAndroid() {
    return /Android/i.test(navigator.userAgent);
}
function $31691340282c7066$var$evaluateRedirectUri(responseRedirectUri) {
    return $31691340282c7066$var$checkMobile() === true ? $31691340282c7066$var$createMobileRedirectUri(responseRedirectUri) : responseRedirectUri;
}
function $31691340282c7066$var$createMobileRedirectUri(responseRedirectUri) {
    const url = new URL(responseRedirectUri);
    const baseUrl = url.origin;
    const mobileDashboardUrl = baseUrl + $31691340282c7066$var$MOBILE_REDIRECT_ROUTE;
    return mobileDashboardUrl;
}
function $31691340282c7066$var$navigateToApp(redirectUrl) {
    if ($31691340282c7066$var$isAndroid()) window.location.replace(redirectUrl);
    else window.location.href = redirectUrl;
}
function $31691340282c7066$var$setLoginLocalStorage(username, password) {
    if (username) localStorage.setItem($31691340282c7066$var$userField, btoa(username));
    if (password) localStorage.setItem($31691340282c7066$var$passField, btoa(password));
    return true;
}
function $31691340282c7066$var$getLoginLocalStorage(userField, passField) {
    if ($31691340282c7066$var$getCookie("email") != null && $31691340282c7066$var$getCookie("password") != null) $31691340282c7066$var$setLoginLocalStorage($31691340282c7066$var$getCookie("email"), $31691340282c7066$var$getCookie("password"));
    // console.log(userField);
    let user = localStorage.getItem(userField);
    let pass = localStorage.getItem(passField);
    if (user == null || pass == null) return {
        user: user,
        pass: pass
    };
    else return {
        user: atob(user),
        pass: atob(pass)
    };
}
function $31691340282c7066$var$clearLoginLocalStorage(userField, passField) {
    localStorage.removeItem(userField);
    localStorage.removeItem(passField);
    return true;
}
//Hide signup stuff from IOS because Apple is a pain.
if (navigator.userAgent.includes("iPhone")) document.getElementById("signUpDiv").style.display = "none";
const $31691340282c7066$var$togglePassword = document.querySelector("#togglePassword");
const $31691340282c7066$var$password = document.querySelector("#password");
$31691340282c7066$var$togglePassword.addEventListener("click", function(e) {
    // toggle the type attribute
    const type = $31691340282c7066$var$password.getAttribute("type") === "password" ? "text" : "password";
    $31691340282c7066$var$password.setAttribute("type", type);
    // toggle the eye slash icon
    this.classList.toggle("fa-eye-slash");
    this.classList.toggle("fa-eye");
}); // ESignatureVerification needs to let the parent know about sso logins
 // if (isESignatureVerification) {
 //    const params = new Proxy(new URLSearchParams(window.location.search), {
 //       get: (searchParams, prop) => searchParams.get(prop),
 //    });
 //    if (params.error) {
 //       window.parent.postMessage(
 //          {
 //             success: false,
 //             user: 0
 //          },
 //          routes.appUrl
 //       );
 //       return;
 //    }
 //    if (params.sso === "true") {
 //       const eSignatureVerificationToken = params.eSignatureVerificationToken;
 //       const eSignatureVerificationTokenCookie = getCookie("eSignatureVerificationToken");
 //       if (eSignatureVerificationToken === eSignatureVerificationTokenCookie) {
 //          delete_cookie("eSignatureVerificationToken", "/", "window.location.hostname");
 //          window.parent.postMessage(
 //             {
 //                success: true,
 //                user: params.userID
 //             },
 //             routes.appUrl
 //          );
 //       }
 //    }
 // }


//# sourceMappingURL=views.1a47c83b.js.map
